export const i18n_en = {
  close_btn: 'Close',
  search_placeholder: 'Search',
  loading: 'Loading',

  label_inactive: 'Inactive',
  label_invalid: 'Invalid',

  active_devices: 'Devices {{devices_len}} active',
  change_language: 'Change language',
  language_changed_message: 'Language changed',

  error_select_device_message: 'Please select device first',
  select_device: 'Select device',
  select_company_menu_message: 'Select company to view devices list',
  select_company_required_header: 'Select a company to proceed',
  select_company_required_from: 'From here: ',
  select_company_required_accounts_page_link: 'Accounts Page',

  second: 'second',
  seconds: 'seconds',
  second_one: 'second',
  second_other: 'seconds',
  minute: 'minute',
  minutes: 'minutes',
  minute_one: 'minute',
  minute_other: 'minutes',
  hour: 'hour',
  hours: 'hours',
  hour_one: 'hour',
  hour_other: 'hours',
  day: 'day',
  day_one: 'day',
  day_other: 'days',
  start_date: 'Start Date',
  end_date: 'End Date',
  from_date: 'From Date',
  to_date: 'To Date',
  avg_from_date: 'Average From Date',
  avg_to_date: 'Average To Date',
  period: 'Period',
  description: 'Description',
  date: 'Date',
  number: 'Number',
  apply: 'Apply',
  update: 'Update',
  create: 'Create',
  delete: 'Delete',
  export: 'Export',
  rssi: 'rssi',
  ber: 'ber',
  reading: 'Reading',
  model: 'Model',
  email_address: 'Email Address',
  password: 'Password',
  confirm_password: 'Confirm Password',
  sign_in: 'Sign In',
  graph: 'Graph',
  no_data: 'No data',
  every: 'Every',
  for_company: 'For company',
  flow: 'Flow',
  no_data_found: 'No data found.',
  percent: 'Percent',
  device_number_devicenum: 'Device number: {{device_number}}',
  device_number: 'Device number',
  device_name: 'Device name',
  successfully_saved: 'Successfully saved',
  error_occured: 'An error occurred',
  none: 'None',
  off: 'Off',
  no_unit: 'No unit',
  hardware_version: 'Hardware Version',
  software_version: 'Software Version',
  transmission_period: 'Transmission Period',
  record_period: 'Record Period',
  replacement_number: 'Replacement Number',
  replaced_by: 'Replaced By',

  createdOn: 'Created On',
  createdBy: 'Created By',

  show_average: 'Show Average',
  show_readings: 'Show Readings',

  yes: 'Yes',
  no: 'No',
  capital_yes: 'YES',
  capital_no: 'NO',

  sensor: 'Sensor',

  all_sensors: 'All Sensors',

  select_all: 'Select all',
  deselect_all: 'Deselect all',

  function_last: 'Last',
  function_first: 'First',
  function_avg: 'Average',
  function_min: 'Min',
  function_max: 'Max',
  function_median: 'Median',
  function_count: 'Count',
  function_last_flow: 'Last Flow',
  function_first_flow: 'First Flow',
  function_avg_flow: 'Average Flow',
  function_max_flow: 'Max Flow',
  function_min_flow: 'Min Flow',
  function_median_flow: 'Median Flow',

  page_title_header_number_with_name_absent: '{{title}} - {{device_number}}',
  page_title_header_number_with_name_present: '{{title}} - {{device_name}} ({{device_number}})',

  error_forbidden_operation_not_allowed: 'Not Allowed',

  not_set: 'Not set',

  //Sensor Types
  generic_analog_sensor: 'Generic Analog Sensor',
  generic_virtual_sensor: 'Generic Virtual Sensor',
  generic_digital_sensor: 'Generic Digital Sensor',
  modbus_generic_analog_sensor: 'Modbus Generic Analog Sensor',
  modbus_generic_digital_sensor: 'Modbus Generic Digital Sensor',
  pressure_sensor: 'Pressure Sensor',
  temperature_sensor: 'Temperature Sensor',
  humidity_sensor: 'Humidity Sensor',
  level_sensor: 'Level Sensor',
  weight_meter: 'Weight Meter',
  weight_sensor: 'Weight Sensor',
  load_cells: 'Load Cells',
  wind_direction_sensor: 'Wind Direction Sensor',
  barometric_pressure_sensor: 'Barometric Pressure Sensor',
  soil_moisture_sensor: 'Soil Moisture Sensor',
  dew_point_sensor: 'Dew Point Sensor',
  soil_temperature_sensor: 'Soil Temperature Sensor',
  soil_potential_sensor: 'Soil Potential Sensor',
  particulate_matter_sensor: 'Particulate Matter Sensor',
  leaf_wetness_sensor: 'Leaf Wetness Sensor',
  gnss_sensor: 'GNSS Sensor',
  water_meter: 'Water Meter',
  power_meter: 'Power Meter',
  gas_flow_meter: 'Gas Flow Meter',
  rain_sensor: 'Rain Sensor',
  wind_speed_sensor: 'Wind Speed Sensor',
  heat_meter: 'Heat Meter',
  geiger_mueller_counter: 'Geiger Muller Counter',
  on_off_sensor: 'On/Off Sensor',
  on_off_input_sensor: 'On/Off Input Sensor',
  on_off_output_sensor: 'On/Off Output Sensor',
  on_off_auto_output_sensor: 'On/Off/Auto Output Sensor',
  tasmota_relay_sensor: 'Tasmota Relay Sensor',
  modbus_generic_on_off_input_sensor: 'Modbus Generic On/Off Input Sensor',
  modbus_generic_on_off_output_sensor: 'Modbus Generic On/Off Output Sensor',
  co_sensor: 'CO Sensor',
  no2_sensor: 'NO2 Sensor',
  so2_sensor: 'SO2 Sensor',
  tasmota_generic_digital_sensor: 'Tasmota Generic Digital Sensor',
  tasmota_alarm_input_sensor: 'Tasmota Alarm Input Sensor',
  tasmota_generic_analog_sensor: 'Tasmota Generic Analog Sensor',

  //Port Types
  digital_input_port: 'Digital Input Port',
  pulse_input_port: 'Pulse Input Port',
  pulse_s0_input_port: 'Pulse S0 Input Port',
  analog_input_port: 'Analog Input Port',
  '4_20_mA_input_port': '4-20mA Input Port',
  '0_5_V_input_port': '0-5V Input Port',
  on_off_input_port: 'On/Off Input Port',
  on_off_output_port: 'On/Off Output Port',
  generic_modbus_on_off_input_port: 'Generic Modbus On/Off Input Port',
  generic_modbus_on_off_output_port: 'Generic Modbus On/Off Output Port',

  // duration
  duration_years_one: '{{count}} year',
  duration_years_other: '{{count}} years',
  duration_months_one: '{{count}} month',
  duration_months_other: '{{count}} months',
  duration_months_abbr: 'mos.',
  duration_days_one: '{{count}} day',
  duration_days_other: '{{count}} days',
  duration_hours_one: '{{count}} hour',
  duration_hours_other: '{{count}} hours',
  duration_minutes_one: '{{count}} minute',
  duration_minutes_other: '{{count}} minutes',
  duration_seconds_one: '{{count}} second',
  duration_seconds_other: '{{count}} seconds',

  years: 'Years',
  months: 'Months',
  days: 'Days',

  /*
   * |===============|
   * | Period Picker |
   * |===============|
   */
  period_date_range: 'Date Range',
  period_custom: 'Custom',
  period_today: 'Today',
  period_week: 'Week',
  period_month: 'Month',
  period_yesterday: 'Yesterday',
  period_last_week: 'Last week',
  period_last_month: 'Last month',
  period_last_1_hours: 'Last hour',
  period_last_2_hours: 'Last 2 hours',
  period_last_4_hours: 'Last 4 hours',
  period_last_24_hours: 'Last 24 hours',
  period_last_48_hours: 'Last 48 hours',

  /*
   * |=====================|
   * | Hook Error Messages |
   * |=====================|
   */
  error_cannot_fetch_device: 'Could not fetch device.',
  error_cannot_fetch_device_config: 'Could not fetch device config.',
  error_cannot_fetch_ports_config: 'Could not fetch ports config.',
  error_cannot_fetch_flow_stats: 'Could not fetch flow statistics.',
  error_cannot_fetch_time_stats: 'Could not fetch time statistics.',
  error_cannot_fetch_general_stats: 'Could not fetch general statistics.',
  error_cannot_fetch_qflow_stats: 'Could not fetch qflow statistics.',

  signup_company_name: 'Company Name',

  sign_up_form_first_name: 'First Name',
  sign_up_form_last_name: 'Last Name',
  sign_up_form_email: 'Email Address',
  sign_up_form_password: 'Password',
  sign_up_form_confirm_password: 'Confirm Password',
  sign_up_form_company_name: 'Company Name',

  button_save: 'Save',
  button_apply: 'Apply',
  button_update: 'Update',
  button_create: 'Create',
  button_delete: 'Delete',
  button_continue: 'Continue',
  button_back: 'Back',
  dashboard_tour_back: 'Back',
  dashboard_tour_next: 'Next',
  dashboard_tour_finish: 'Finish',
  dashboard_tour_close: 'Close',
  dashboard_tour_open: 'Open the dialog',
  dashboard_tour_skip: 'Skip',
  dashboard_tour_next_with_progress: 'Next ({current} of {total})',
  capital_add_btn: 'ADD',
  capital_create_btn: 'CREATE',
  capital_update_btn: 'UPDATE',
  capital_remove_btn: 'REMOVE',
  capital_cancel_btn: 'CANCEL',

  role_roles: 'Roles',
  role_user: 'User',
  role_public: 'Public',
  role_admin: 'Admin',
  role_billing: 'Billing',
  role_super_admin: 'Super Admin',
  role_restricted: 'Restricted',

  device_counters_cumulative_graph_graph: 'Graph, device number: {{device_number}}',
  device_counters_cumulative_graph_must_have_analog_sensor: 'Must have an enabled analog sensor.',

  confirm_registration_welcome_to_thingslog: 'Welcome to Thingslog!',
  confirm_registration_completed: 'REGISTRATION COMPLETED',
  confirm_registration_failed: 'REGISTRATION FAILED',
  confirm_registration_completed_description:
    'Your registration process is completed. You can login now. If you face issue, contact our support at {{email}}',
  confirm_registration_failed_description:
    'We encountered a problem with registration. If you face issues logging in, please, contact our support at {{email}}',
  confirm_registration_visit_website: 'Visit Our Website',
  confirm_registration_visit_ecommerce: 'Visit Our Online Store',

  sensor_statistics_min: 'Min: {{min}}',
  sensor_statistics_max: 'Max: {{max}}',
  sensor_statistics_avg: 'Avg: {{avrg}}',
  sensor_statistics_total: 'Total: {{total}}',

  chart_statistics_min: 'Min:',
  chart_statistics_max: 'Max:',
  chart_statistics_avg: 'Avg:',
  chart_statistics_total: 'Total:',

  menu_main: 'Main',
  menu_device: 'Device',

  submenu_devices: 'Devices',
  submenu_account: 'Account',
  submenu_device_reports: 'Device Reports',
  submenu_settings: 'Settings',

  link_selected_device: 'Selected Device',
  link_device_nodes: 'Device Nodes',
  link_devices: 'Devices List',
  link_accounts: 'Accounts',
  link_utility_rate: 'Utility Rates',
  link_link_device: 'Link Device',
  link_create_user: 'Create User',
  link_icons: 'Icons',
  link_licenses: 'Licenses',
  link_accounts_manager: 'Create Account',
  link_transmissions: 'Transmissions',
  link_map: 'Map',
  link_inventory: 'Inventory',
  link_devices_manager: 'Device Manager',
  link_battery: 'Battery',
  device_groups: 'Device Groups',
  link_signal: 'Signal',
  link_alarms: 'Alarms',
  link_value_ranges: 'Value Range Events',
  link_device_account_lookup: 'Device Account Lookup',
  link_show_users: 'Users',
  link_dashboard: 'Dashboard',
  link_dashboard_2: 'Dashboard 2',
  link_reports: 'Reports',
  link_scheduled_reports: 'Scheduled Reports',
  link_billing_report: 'Billing Report',

  link_all_devices: 'All Devices',
  link_readings: 'Readings',
  link_sensors_data: 'Sensors Data',
  link_flow: 'Flow',
  link_graph: 'Graph',
  link_new_graph: 'Instant Graph',
  link_pump_control: 'Pump Control',
  link_relay_control: 'Relay Control',
  link_alarm_config: 'Alarm Config',
  link_statistics: 'Statistics',
  link_customer: 'Customer',
  link_meter: 'Meter',
  link_config: 'Config Synchronization',
  link_initial_config: 'Initial Config (old)',
  link_sensor_config: 'Sensor Config (old)',
  link_sensors_and_network_config: 'Parameters Configuration',
  link_export: 'Export',
  link_customer_billing_report: 'Customer Billing Report',
  link_flow_generator: 'Flow Generator',
  link_commands: 'Commands',
  link_copy_config: 'Copy Config',
  switch_to_new_menu_label: 'Use new menu',
  switch_to_old_menu_label: 'Use old menu',

  link_profile: 'Profile',
  link_language: 'Language',
  link_sign_out: 'Sign Out',

  chip_early_access: 'Early Access',

  pulse_sensor_1: 'Pulse Sensor 1',
  pulse_sensor_2: 'Pulse Sensor 2',
  analog_sensor_1: 'Analog Sensor 1',
  analog_sensor_2: 'Analog Sensor 2',
  analog_sensor_3: 'Analog Sensor 3',
  analog_sensor_4: 'Analog Sensor 4',
  analog_sensor_5: 'Analog Sensor 5',
  analog_sensor_6: 'Analog Sensor 6',
  analog_sensor_7: 'Analog Sensor 7',
  analog_sensor_8: 'Analog Sensor 8',
  on_off_sensor_1: 'On/Off Sensor 1',
  on_off_sensor_2: 'On/Off Sensor 2',
  on_off_sensor_3: 'On/Off Relay 1',
  on_off_sensor_4: 'On/Off Relay 2',

  device_icon: 'Device Icon',
  sensor_icon: 'Sensor Icon',
  icon_no_icon: 'No Icon',
  icon_barometer: 'Barometer',
  icon_door_closed: 'Door Closed',
  icon_door_open: 'Door Open',
  icon_electricity: 'Electricity',
  icon_energy_meter: 'Energy Meter',
  icon_gas_flow_meter: 'Gas Flow Meter',
  icon_gas: 'Gas',
  icon_generic_particle_meter: 'Generic Particle Meter',
  icon_generic: 'Generic',
  icon_heat_meter: 'Heat Meter',
  icon_humidity: 'Humidity',
  icon_leaf_moisture: 'Leaf Moisture',
  icon_level_metering: 'Level Metering',
  icon_pivot: 'Pivot',
  icon_pressure: 'Pressure',
  icon_radiation: 'Radiation',
  icon_rain: 'Rain',
  icon_soil_moisture: 'Soil Moisture',
  icon_temperature: 'Temperature',
  icon_water_meter: 'Water Meter',
  icon_water: 'Water',
  icon_wind_direction: 'Wind Direction',
  icon_wind_speed: 'Wind Speed',
  icon_pump: 'Pump',
  icon_apartment: 'Apartment Building',
  icon_base_station: 'Base Station',
  icon_clinic: 'Clinic',
  icon_hospital: 'Hospital',
  icon_house: 'House',
  icon_mayor_office: "Mayor's Office Building",
  icon_police_station: 'Police Station',
  icon_public_restroom: 'Public Restroom Facility',
  icon_stadium: 'Stadium ',
  icon_gas_station: 'Gas Station',
  icon_controller: 'Controller',

  device_icon_new_portal: 'Icon (new portal)',
  device_icon_old_portal: 'Icon (old portal)',

  very_low_level_alarm: 'Very low level alarm',
  low_level_alarm: 'Low level alarm',
  high_level_alarm: 'High level alarm',
  very_high_level_alarm: 'Very high level alarm',

  sensor_conversion_formula: 'Sensor Conversion Formula',
  delete_old_counters: 'Delete old counters',
  device_config_select_record_period: 'Select Record Period',
  device_config_select_transmission_period: 'Select Transmission Period',

  devices_table_number: 'Number',
  devices_table_name: 'Name',
  devices_table_device_number: 'Device Number',
  devices_table_device_name: 'Device Name',
  devices_table_business_partner: 'Business Partner',
  devices_table_quarter: 'Quarter',
  devices_table_address: 'Address',
  devices_table_error: 'Could not load devices',
  devices_table_no_devices_found: 'No devices found',
  devices_table_description: 'Description',
  devices_column_header_search: 'Search…',

  alarm_config_header: 'Configure alarms',
  alarm_config_notification_email: 'Notification emails',
  alarm_config_notification_email_place_holder: 'Email list (comma separated)',
  alarm_config_missed_transmission_email: 'Missed transmission emails',
  alarm_config_missed_transmission_email_place_holder:
    'Missed transmissions email list (comma separated)',
  alarm_config_high_consumption_threshold:
    'High Consumption Threshold for transmission period {{transmission_every}} {{transmission_period}} [{{units}}]',
  alarm_config_low_flow_alarm_threshold: 'Low Flow Alarm Threshold [{{units}}]',
  alarm_config_high_flow_alarm_threshold: 'High Flow Alarm Threshold [{{units}}]',
  alarm_config_non_zero_consumption_time_range: 'Non-Zero consumption time range',
  alarm_config_high_low_flow_time_range: 'High/Low Flow alarm time range',
  alarm_config_start_time: 'Start time',
  alarm_config_end_time: 'End time',
  alarm_config_flow_calc_time_base: 'Flow calculation time base',
  alarm_config_saved_msg: 'Alarm Configuration Saved.',
  alarm_config_email_validation_error:
    'Please enter valid email addresses, separated by a single comma and no space, with a maximum of 255 characters.',

  alarm_config_non_zero_consumption_time_range_error: 'Must have start time and end time',
  alarm_config_low_flow_severity: 'Low Flow Severity',
  alarm_config_high_flow_severity: 'High Flow Severity',
  alarm_config_high_consumption_severity: 'High Consumption Severity',
  alarm_config_all_zero_severity: 'All Zero Consumption Severity',
  alarm_config_non_zero_consumption_severity: 'Non-Zero Consumption Severity',
  alarm_config_on_off_severity: 'On/Off Severity',

  alarms_title: 'Alarms',
  alarms_title_with_dev_num: 'Alarms, device number: {{device_number}}',
  alarms_type: 'Alarm Type',
  alarms_active_status: 'Activity',
  alarms_active_dropdown_label: 'Active',
  alarms_inactive_dropdown_label: 'Inactive',

  device_battery_title: 'Battery level',
  device_battery_voltage: 'Voltage, mV',
  device_battery_level: 'Level, %',

  device_signal_title: 'Signal strength',

  device_counters_graph_header: 'Consumption Graph',

  device_instant_graph_header: 'Instant Graph',

  devices_signal_title: 'Devices signal',
  devices_signal_level: 'Signal Level',
  devices_signal_level_percent: 'Level, %',

  devices_battery_title: 'Batteries Level',
  devices_battery_level: 'Battery Level, %',
  devices_battery_voltage: 'Voltage, mV',

  reports_export_title: 'Export Reports to file',

  device_counter_export_title: 'Export Device counters, device number: {{device_number}}',

  device_config_record_and_transmission_period: 'Record and transmission periods',
  device_config_record_period: 'Record Period',
  device_config_transmission_period: 'Transmission Period',
  device_config_start_setup: 'Start Setup',
  device_config_setup_message: 'Configuration Saved. Now put a magnet on your device.',
  device_config_header: 'Configure device',
  device_config_config_date: 'Config date: {{date}}',
  device_config_config_status: 'Status',
  device_config_config_status_configured: 'Synced',
  device_config_config_status_not_configured: 'Not Synced',
  device_config_time_zone: 'Time zone',
  device_config_pulse_per: '{{x}} per pulse',
  device_config_sensor_type: 'Sensor Type',
  device_config_meter_type: 'Meter Type',
  device_config_select_time_zone: 'Select time zone',
  device_config_missed_transmission_alarm_severity: 'Missed transmission alarm severity',
  device_config_pulse_coef_not_changed_message:
    'Warning: Custom "Pulse coefficient" remains unaffected by changes in "Initial Reading"',
  device_config_does_not_support_this_model: 'This device model is not supported on this page.',

  device_digits_fraction: 'Fraction',
  device_digits_digits: 'Digits',
  device_digits_initial_reading: 'Initial Reading',
  device_digits_alert_too_many_total_digits: 'The total number of digits should be <= 9',
  device_digits_alert_too_small_total_digits: 'The total number of digits should be >= 4',
  device_digits_alert_too_many_total_fraction:
    'The number of digits after decimal point should be <= 3 and the total number of digits should be <= 9',
  device_digits_alert_too_small_total_fraction:
    'The number of digits after decimal point should be >=0 and the total number of digits should be >= 4',

  device_transmissions_at: 'Device transmissions at {{query_date}}',
  device_transmissions_last_transmission_short: 'Last Trans.',
  device_transmissions_next_transmissions_short: 'Next Trans.',
  device_transmissions_days: 'Days',
  device_transmissions_transmissions_short: 'Trans',
  device_transmissions_count: 'Count',
  device_transmissions_fail: 'Fail',
  device_transmissions_customer: 'Customer',
  device_transmissions_address: 'Address',
  device_transmissions_ok: 'Ok',

  link_device_link_device_to_my_account: 'Link device to my account',
  link_device_device_number: 'Device Number',
  link_device_unlink_device: 'Unlink Device',
  link_device_with_device_number: `Link device: {{device_number}}`,
  unlink_device_with_device_number: `Unlink device: {{device_number}}`,
  link_device_devices_counts:
    'Linked devices: {{linked_devices_count}} / {{allowed_devices_count}}',
  link_device_success_message: 'Device associated successfully',
  unlink_device_success_message: 'Device unlinked successfully from: ',
  link_device_enter_device_number_error: 'Enter a device number',
  link_device_select_company_error: 'Select a company',
  link_device_default_error: 'There was a problem linking/unlinking the device',
  link_device_company_not_found_error: 'Company not found',
  link_device_device_not_found_error: 'Device {{device_number}} was not found',
  link_device_device_not_linked_error: 'Device {{device_number}} is not linked',
  link_device_device_already_linked_error: 'Device {{device_number}} is already linked',
  link_device_device_limit_reached_error: 'Device limit reached',
  link_device_operation_not_allowed_error: 'Operation not allowed',
  link_device_unlink_devices_for_sub_accounts: 'Unlink device for all sub accounts',
  link_device_unlink_devices_for_sub_accounts_tooltip:
    'If checked, device will be unlinked from selected and all sub accounts. If not checked, device will be unlinked only for selected account.',
  link_device_lookup_title: 'Device lookup',
  link_device_lookup_subheader:
    'Click a row in this table to automatically populate the device number in the link device form.',
  link_device_lookup_filter_number: 'Number',
  link_device_lookup_filter_name: 'Name',
  link_device_lookup_device_name: 'Device name',
  link_device_lookup_device_number: 'Device number',
  link_device_lookup_no_devices_found: 'No devices found',

  device_search_device_number: 'Device Number',
  device_search_kicker: 'Company context',
  device_search_title: 'Device company lookup',
  device_search_subtitle:
    'Search by device number and select the company that should stay active in management.',
  device_search_device_number_placeholder: 'Enter device number',
  device_search_length_hint: 'Search starts automatically after you stop typing.',
  device_search_clear: 'Clear',
  device_search_selected_company: 'Selected company',
  device_search_selected_company_hint:
    'Click the same row again to clear the current company selection.',
  device_search_error: 'Failed to load companies for this device number.',
  device_search_no_matches: 'No matching companies were found for this device number.',
  device_search_results_title: 'Matching companies',
  device_search_results_ready: 'Select one row to update the active company context.',
  device_search_results_waiting: 'Enter a device number to start searching.',
  device_search_empty_prompt: 'Enter a device number to search for matching companies.',
  device_search_empty_prompt_subtitle: 'Results will appear here after you stop typing.',
  device_search_domain: 'Domain',

  device_manager_create_or_delete_device: 'Create or delete device: {{device_number}}',
  device_manager_device_number: 'Device Number',
  device_manager_device_model: 'Device Model',
  device_manager_sw_version_validation:
    'The required format is X.X.X or  X.X.X- and X.X.X_ followed by characters, where X is a number',
  device_manager_hw_version_validation: 'The required format is X.X.X where X is a number',
  device_manager_software_version: 'Software Version',
  device_manager_hardware_version: 'Hardware Version',
  dashboard_alarms: 'Alarms',
  dashboard_batteries: 'Batteries',
  dashboard_signal: 'Signal',
  dashboard_transmission: '{{alarm_type}} ({{alarm_count}})',
  dashboard_chart_battery_level: 'Battery level',
  dashboard_chart_signal_level: 'Signal Level',
  dashboard_chart_number_of_devices: 'Number of devices',
  dashboard_select_company_header: 'Select an account to view the dashboard',
  dashboard_select_company_from: 'From here: ',
  dashboard_select_company_accounts_page_link: 'Accounts',

  alarm_type_no_zero_consumption: 'No Zero Consumption',
  alarm_type_high_consumption: 'High Consumption',
  alarm_type_high_flow: 'High Flow',
  alarm_type_missed_transmission: 'Missed Transmission',
  alarm_type_low_flow: 'Low Flow',
  alarm_type_all_zero_consumption: 'All Zero Consumption',
  alarm_type_device_removed: 'Device Removed',
  alarm_type_on_off_alarm: 'On/Off Alarm',
  alarm_type_low_level: 'Low Level Alarm',
  alarm_type_high_level: 'High Level Alarm',
  alarm_type_tamper: 'Tamper',
  alarm_type_oversized: 'Oversized',
  alarm_type_undersized: 'Undersized',
  alarm_type_low_battery: 'Low Battery',
  alarm_type_blockage: 'Blockage',
  alarm_type_burst: 'Burst',
  alarm_type_reverse_flow: 'Reverse Flow',
  alarm_type_range_event: 'Range Event',
  alarm_type_very_low_level: 'Very Low Level',
  alarm_type_very_high_level: 'Very High Level',
  alarm_type_leakage: 'Leakage',
  alarm_type_low_temperature: 'Low Temperature',
  alarm_type_no_consumption: 'No Consumption',
  alarm_type_negative_flow: 'Negative Flow',
  alarm_type_empty_spool: 'Empty Spool',
  alarm_type_combination_of_alarms: 'Combination Of Alarms',
  alarm_type_standstill: 'Standstill',
  alarm_type_reset_error: 'Reset Error',
  alarm_type_rf_error: 'RF Error',
  alarm_type_cs_error: 'CS Error',
  alarm_type_measuring_error: 'Measuring Error',
  alarm_type_reset_event: 'Reset Event',
  alarm_type_magnetic_field: 'Magnetic Field',
  alarm_type_sensor_fraud: 'Sensor Fraud',

  device_counter_graph_min: 'Min: {{min}}',
  device_counter_graph_max: 'Max: {{max}}',
  device_counter_graph_avg: 'Avg: {{avrg}}',
  device_counter_graph_total: 'Total: {{total}}',
  device_counter_graph_average: 'Average:',
  device_counter_graph_no_data: 'No data',
  device_counter_graph_cant_calculate_flow_analog: "Can't calculate flow for an analog sensor!",
  device_counter_graph_must_have_digital_sensor: 'Must have an enabled digital sensor.',

  customer_info_header: 'Customer Info',
  customer_info_business_partner_number: 'Business Partner Number',
  customer_info_contact_data: 'Contact Data',
  customer_info_contract_number: 'Client Contract Number',
  customer_info_name: 'Name',
  customer_info_description: 'Description',
  customer_info_billing_group: 'Billing Group',
  customer_info_municipality: 'Municipality',
  customer_info_quarter: 'Quarter',
  customer_info_street: 'Street',
  customer_info_block: 'Block',
  customer_info_entr: 'Entr.',
  customer_info_customer_type: 'Customer Type',
  customer_info_customer_type_commercial: 'Commercial',
  customer_info_customer_type_domestic: 'Domestic',
  customer_info_customer_type_block_of_flats: 'Block of Flats',
  customer_info_customer_type_budget: 'Budget',

  meter_info_meter_info: 'Meter Info: {{device_number}}',
  meter_info_factory_number: 'Factory Number',
  meter_info_brand: 'Brand',
  meter_info_enter_diameter: 'Enter Diameter',
  meter_info_mount_date: 'Mount Date',
  meter_info_meter_info_saved: 'Meter Info Saved.',

  device_initial_config_header: 'Device Initial Config',
  device_initial_device_model: 'Device Model',
  device_initial_config_address: 'Address',
  device_initial_config_port: 'Port',
  device_initial_config_resolve_address: 'Resolve Address (use DNS)',
  device_initial_config_simcard_provider: 'SimCard Provider',
  device_initial_config_simcard_number: 'SimCard Number',
  device_initial_config_bands: 'bands',
  device_initial_config_OTAA_appkey: 'OTAA - appkey',
  device_initial_config_OTAA_deveui: 'OTAA - deveui',
  device_initial_config_OTAA_appeui: 'OTAA - appeui',
  device_initial_config_ABP_appskey: 'ABP - appskey',
  device_initial_config_ABP_nwkskey: 'ABP - nwkskey',
  device_initial_config_ABP_devaddr: 'ABP - devaddr',
  device_initial_config_ABP_deveui: 'ABP - deveui',
  device_initial_config_lora_app_mode: 'App mode',
  device_initial_config_app_id: 'App Id',
  device_initial_config_profile_id: 'Profile Id',
  device_initial_config_platform_name: 'Platform Name',
  device_initial_config_thingslog_lora_platform: 'ThingsLog LoRa Platform',
  device_receive_data_binary: 'Receive Data Binary',
  device_send_data_binary: 'Send Data Binary',
  device_mqtt_config: 'MQTT Config',
  device_mqtt_config_qos: 'Quality of Service',
  device_mqtt_config_username: 'Username',
  device_mqtt_config_password: 'Password',
  device_mqtt_config_certificate: 'Certificate',
  device_initial_config_apn_username: 'APN Username',
  device_initial_config_apn_password: 'APN Password',
  device_initial_config_net_attached_delay: 'Transmission Delay',
  device_initial_config_gprs_radio_mode: 'GPRS Radio Mode',
  device_initial_config_grps_radio_mode_auto_option: 'Auto',
  device_initial_config_preferred_network_type: 'Preferred Network Type',
  device_initial_config_preferred_network_default_option: 'Default',
  device_initial_config_mcc_mnc: 'MCC-MNC',
  device_initial_config_slave_devices: 'Slave Devices',
  device_initial_config_modbus_address: 'Modbus Address',
  device_initial_config_modbus_master_device: 'Master Device Number',
  device_initial_config_trashcan_brand: 'Brand',
  device_initial_config_trashcan_model: 'Model',
  device_initial_config_trashcan_volume: 'Volume',
  device_initial_config_trashcan_max_weight: 'Max Weight',
  device_initial_config_trashcan_material: 'Material',
  device_initial_config_trashcan_color: 'Color',
  device_initial_config_trashcan_waste_type: 'Waste Type',
  device_initial_config_trashcan_waste_type_plastic: 'Plastic',
  device_initial_config_trashcan_waste_type_bio: 'Bio',
  device_initial_config_trashcan_waste_type_paper: 'Paper',
  device_initial_config_trashcan_waste_type_glass: 'Glass',
  device_initial_config_trashcan_waste_type_metal: 'Metal',
  device_initial_config_trashcan_waste_type_mixed: 'Mixed',
  device_initial_config_trashcan_waste_type_other: 'Other',
  device_initial_config_trashcan_pricing: 'Pricing',
  device_initial_config_trashcan_pricing_free: 'Free',
  device_initial_config_trashcan_pricing_per_lift: 'Per Lift',
  device_initial_config_trashcan_pricing_per_kg: 'Per Kg',
  device_initial_config_trashcan_pricing_per_subscription: 'Per Subscription',
  device_initial_config_trashcan_placement: 'Placement',
  device_initial_config_trashcan_placement_on_the_street: 'On the Street',
  device_initial_config_trashcan_placement_inside: 'Inside',
  device_initial_config_trashcan_placement_backyard: 'Backyard',
  device_initial_config_trashcan_customer_community_id: 'Customer Community ID',
  device_initial_config_trash_truck_brand: 'Brand',
  device_initial_config_trash_truck_plate_number: 'Plate Number',
  device_initial_config_trash_truck_model: 'Model',
  device_initial_config_find_encryption_key_by_device_number:
    'Find Encryption Key by Device Number',

  sensor_config_header: 'Sensor Config',
  sensor_config_name: 'Name',
  sensor_config_sensor_name: 'Sensor Name',
  sensor_config_sensor_icon: 'Sensor Icon',
  sensor_config_description: 'Description',
  sensor_config_model: 'Model',
  sensor_config_serial_number: 'Serial Number',
  sensor_config_manufacturer: 'Manufacturer',
  sensor_config_diameter: 'Diameter',
  sensor_config_price: 'Price',
  sensor_config_currency: 'Currency',
  sensor_config_supported_visualization_types: 'Supported Visualization Types',
  sensor_config_port_type: 'Port Type',
  sensor_config_port_type_digital_input_port: 'Digital Input Port',
  sensor_config_port_type_analog_input_port: 'Analog Input Port',
  sensor_config_port_type_pulse_s0_input_port: 'Pulse S0 Input Port',
  sensor_config_port_type_pulse_input_port: 'Pulse Input Port',
  sensor_config_port_type_on_off_input_port: 'On Off Input Port',
  sensor_config_port_type_on_off_output_port: 'On Off Output Port',
  sensor_config_port_conversion_formula: 'Port Conversion Formula',
  sensor_config_formula: 'Formula',
  sensor_config_offset: 'Offset',
  sensor_config_sensor_index_tooltip: 'Sensor index: {{sensor_index}}',
  sensor_config_visible: 'Visibility',
  sensor_config_order_number: 'Order Number',
  sensor_config_visible_true: 'Visible',
  sensor_config_visible_false: 'Invisible',
  sensor_config_use_in_sensor_aggregation: 'Use In Sensor Aggregation',
  sensor_config_use_in_sensor_aggregation_true: 'Use',
  sensor_config_use_in_sensor_aggregation_false: 'Do Not Use',
  sensor_config_value_labels: 'Value Labels',
  sensor_config_label_for_value_zero: 'Label for value "0"',
  sensor_config_label_for_value_one: 'Label for value "1"',
  sensor_config_inverted_read_state_value: 'Inverted Read State',
  sensor_config_inverted_read_state_value_true: 'Inverted',
  sensor_config_inverted_read_state_value_false: 'Non-inverted',
  sensor_config_register_address: 'Register Address',
  sensor_config_data_type: 'Data Type',
  sensor_config_count: 'Count',
  sensor_config_number_registers: 'Number of Registers',
  sensor_config_particle_size: 'Particle size',
  sensor_config_power: 'Power',
  sensor_config_measurement_type: 'Measurement Type',
  sensor_config_measurement_group: 'Measurement Group',

  device_counter_statistics_statistics_id: 'Statistics, id: {{device_number}}, {{description}}',
  device_counter_statistics_quarter: 'Quarter',
  device_counter_statistics_flow: 'Flow',
  device_counter_statistics_hour: 'Hour',
  device_counter_statistics_quantity: 'Quantity',
  device_counter_statistics_value: 'Value',
  device_counter_statistics_digital_ports_must_be_present:
    'You must have a pulse input connected to a water meter sensor to see this table.',
  device_counter_statistics_must_have_initialized_params:
    'Parameters Q3, R, and Diameter are required on pulse input connected to a water meter sensor.',

  company_manager_title: 'Create or delete account: {{company_name}}',
  company_manager_account_name: 'Account Name',
  company_manager_solution: 'Solution Type',
  company_manager_solution_option_none: 'None',
  company_manager_solution_option_agri: 'Smart Agriculture',
  company_manager_solution_option_air_quality: 'Air quality monitoring',
  company_manager_solution_option_street_lights: 'Street light monitoring',
  company_manager_solution_option_pump_station: 'Pumping Station monitoring',
  company_manager_solution_option_smart_waste: 'Smart Waste',
  company_manager_solution_option_level: 'Level monitoring',
  company_manager_solution_option_gas: 'Gas monitoring',
  company_manager_solution_option_pressure: 'Pressure monitoring',
  company_manager_solution_option_smart_water: 'Smart Water',
  company_manager_solution_option_environment_monitoring: 'Environment monitoring',
  company_manager_solution_option_energy: 'Energy monitoring',
  company_manager_license: 'License',
  company_manager_account: 'Account',
  company_manager_create_company: 'Create Account',
  company_manager_create_company_error: 'There was a problem with creating your account',
  company_manager_license_info_box:
    'The license attachment requires a valid Account ID. Double-check your Account ID value if you want to include it in the creation process.',
  company_manager_valid_from: 'Valid From',
  company_manager_valid_to: 'Valid To',
  company_manager_solution_type: 'Solution Type',
  company_manager_contact_id: 'Contact ID',
  company_manager_account_id: 'Account ID',
  company_manager_license_type: 'License Type',
  company_manager_timezone: 'Timezone',
  company_manager_country: 'Country',
  company_manager_countries_error: 'Could not load countries',
  company_manager_timezones_error: 'Could not load timezones',
  company_manager_account_info: 'Account Info',
  company_manager_address: 'Address',
  company_manager_city: 'City',
  company_manager_municipality: 'Municipality',
  company_manager_area: 'Area',
  company_manager_zip_code: 'ZIP Code',
  company_manager_vat_number: 'VAT Number',
  company_manager_account_ext_number: 'External Account Number',
  company_manager_account_ext_type: 'External Account Type',
  company_manager_account_ext_type_none: 'None',
  company_manager_account_ext_type_household: 'Household',
  company_manager_account_ext_type_business: 'Business',

  company_manager_license_per_device: 'Per Device',
  company_manager_license_per_reading: 'Per Reading',
  company_manager_license_per_sensor: 'Per Sensor',
  company_manager_license_per_poc: 'Per Proof of Concept (POC)',
  company_manager_license_per_remote_node: 'Per Remote Node',

  company_manager_creating_account: 'Creating account: {{company_name}}',
  company_manager_deleting_account: 'Deleting account: {{company_name}}',
  company_manager_account_created: 'Account created successful',
  company_manager_account_deleted: 'Account deleted successful',

  company_manager_update_company: 'Update Account',
  company_manager_delete_company: 'Delete Account',
  company_manager_actions: 'Actions',
  company_manager_delete_modal_description:
    'Are you sure you want to delete this account, the action is irreversible?',
  company_manager_confirm_button: 'Confirm',
  company_manager_cancel_button: 'Cancel',
  company_manager_delete_company_error_message: 'An error occured during deleting the account',
  company_manager_update_btn: 'Update',
  company_manager_child_company_warning_message: 'Creating a sub-account of',
  company_manager_current_logged_in_company: 'the account you are currently logged into',
  company_manager_current_selected_company: 'the account you have currently selected',
  accounts_child_companies: 'Child Companies',
  accounts_contactRef: 'Contact ID',
  accounts_externalNumber: 'External Number',
  accounts_accountRef: 'Account ID',
  accounts_logo: 'Logo',
  accounts_info_unavailable: 'No company information is available for this account.',
  company_manager_accountRef_is_disabled_because_of_license_type:
    'Account ID is disabled because there is per POC license',
  accounts_none: 'None',
  company_manager_update_company_success: 'Account updated successfully',
  company_manager_update_company_error: 'An error occurred while updating account',
  company_manager_account_name_exists: 'An account with this name already exists.',

  license_manager_title: 'Update license: {{company_name}}',
  license_manager_license: 'License',
  license_manager_license_updated: 'License updated',

  companies_title: 'Number of accounts: {{company_number}}',
  companies_table_name: 'Name',
  companies_number_of_accounts: 'Number of accounts:',
  companies_search: 'Search',

  users_title: 'Users',
  units_type: 'Units Type',

  reports_export_format_type: 'Format',

  login_form_forgot_password: 'Forgot password?',

  pump_auto_every: 'Auto every {{secs}} secs',
  pump_svg_last_updated: 'Last updated: {{timestamp}}',
  pump_svg_power_supply: 'Power Supply',
  pump_svg_water_level_controller: 'Water Level Controller',
  pump_svg_pump: 'Pump',
  pump_svg_level_sensor: 'Level Sensor',
  pump_svg_pump_on_sensor: 'Pump-on Sensor',
  pump_svg_pump_off_sensor: 'Pump-off Sensor',
  pump_svg_dry_run_sensor: 'Dry Run Sensor',

  /*
   * |===============|
   * | Device Groups |
   * |===============|
   */

  // Errors
  device_groups_error_please_select_company: 'Please select a company.',

  // Buttons
  device_groups_btn_add: 'Add',
  device_groups_btn_edit: 'Edit',
  device_groups_btn_cancel: 'Cancel',
  device_groups_btn_delete: 'Delete',
  device_groups_color_picker_label: 'Device Group Color',

  // Tooltips
  device_groups_tooltip_edit: 'Edit',
  device_groups_tooltip_delete: 'Delete',

  // Page
  device_groups_name: 'Name',
  device_groups_devices: 'Devices',
  device_groups_view_devices: 'View {{count}} devices',
  device_groups_group_name: 'Group Name',
  device_groups_parent_device_group: 'Parent Device Group',
  device_groups_auto_device_group_type_label: 'Automatic Device Group',
  device_groups_auto_device_group_type_none: 'No automatic group',
  device_groups_auto_device_group_type_all_devices: 'All devices',
  device_groups_auto_device_group_type_all_water: 'All water',
  device_groups_auto_device_group_type_all_energy: 'All energy',
  device_groups_auto_device_group_type_all_pressure: 'All pressure',
  device_groups_auto_device_group_type_all_barometric_pressure: 'All barometric pressure',
  device_groups_auto_device_group_type_all_levels: 'All levels',
  device_groups_auto_device_group_type_all_soil_moisture: 'All soil moisture',
  device_groups_auto_device_group_type_all_air_humidity: 'All air humidity',
  device_groups_auto_device_group_type_all_temperatures: 'All temperatures',
  device_groups_auto_device_group_type_all_pm10: 'All PM10',
  device_groups_auto_device_group_type_all_pm2_5: 'All PM2.5',
  device_groups_auto_device_group_type_unknown: 'Unknown automatic group',
  device_groups_auto_device_group_alert_title: 'Automatic device group enabled',
  device_groups_auto_device_group_alert_description: 'This group is configured as {{type}}.',
  device_groups_auto_device_group_change: 'Change',
  device_groups_auto_device_group_change_modal_title: 'Change automatic device group',
  device_groups_menuitem_none: 'None',
  device_groups_add_device_group: 'Add Device Group',
  device_groups_edit_device_group: 'Edit Device Group',
  device_groups_delete_device_group: 'Delete Device Group',

  device_grous_add_sensor_device: 'Add sensor and device to group',

  device_groups_table_sensor_group_name_header: 'Sensor Group Name',
  device_groups_table_parent_group_name_header: 'Parent Group Name',
  device_groups_table_device_count_header: 'Device Count',

  device_groups_sensor_table_device_number_header: 'Device Number',
  device_groups_sensor_table_sensor_name_header: 'Sensor Name',
  device_groups_sensor_table_sensor_index_header: 'Sensor Index',
  device_groups_sensor_table_select_message: 'Select a sensor group',

  device_groups_sensors_add_modal_device_placeholder: 'Device Number',
  device_groups_sensors_add_modal_sensor_placeholder: 'Sensor',
  device_groups_sensors_add_modal_device_group_name_required: 'Device group name is required',

  device_groups_sensors_delete_description:
    'Deleting this configuration will permanently remove it from the server.',
  device_groups_device_group_delete_description:
    'Deleting the device group will permanently remove it from the server.',

  device_groups_select_company_header: 'Select a company to proceed',
  device_groups_select_company_from: 'From here: ',
  device_groups_select_company_accounts_page_link: 'Accounts Page',

  device_groups_create_device_group_error: 'There was a problem creating a new device group',
  device_groups_update_device_group_error: 'There was a problem updating the device group',
  device_groups_delete_device_group_error: 'There was a problem deleting the device group',
  device_groups_add_device_sensor_device_group_error: 'There was a problem adding the sensor',
  device_groups_remove_device_sensor_device_group_error: 'There was a problem removing the sensor',

  /*
   * |==============|
   * | Users Config |
   * |==============|
   */

  //Page
  users_header: 'Users',
  users_table_username: 'Username',
  users_table_first_name: 'First Name',
  users_table_last_name: 'Last Name',
  users_table_company_name: 'Account',
  users_table_email: 'Email',

  //Filters
  users_filter_username: 'Filter Username',
  users_filter_first_name: 'Filter First Name',
  users_filter_last_name: 'Filter Last Name',
  users_filter_email: 'Filter Email',
  users_filter_company_name: 'Filter Account',
  users_reset_filter_icon: 'Reset Filters',
  users_table_is_contact_person: 'Contact Person',

  //Modals
  users_add_modal_header: 'Add User',
  users_update_modal_header: 'Update User',
  user_remove_modal_icon: 'Delete User',
  users_remove_modal_header: 'Are you sure you want to delete user {{username}}?',
  users_remove_modal_body:
    'Clicking remove will permanently delete the chosen user from the server',
  users_is_dashboard_enabled: 'Enable Dashboard',
  users_is_contact_person: 'Contact Person',

  //Errors
  users_password_match: 'Passwords do not match',
  users_email_blank: 'Email cannot be blank',
  users_load_error: 'Could not load users',
  users_update_error: 'Could not update user',
  users_delete_error: 'Could not delete user',
  users_create_error: 'Could not create user',

  // Success
  users_update_success: 'User updated successfully',
  users_delete_success: 'User deleted successfully',
  users_create_success: 'User created successfully',
  /*
   * |=====================|
   * | Value Ranges Config |
   * |=====================|
   */

  // Buttons & tooltips
  value_ranges_btn_add: 'Add',
  value_ranges_btn_defaults: 'Defaults',
  value_ranges_line_color: 'Line Color',
  value_ranges_node_color: 'Node Color',
  value_ranges_foreground_color: 'Foreground Color',
  value_ranges_background_color: 'Background Color',
  value_ranges_loading: 'Loading...',
  value_ranges_nothing_to_show: 'Nothing to show',

  //Page
  value_ranges_header: 'Value Range Events',
  value_ranges_trigger: 'Trigger',
  value_ranges_notifications: 'Notifications',
  value_ranges_before: 'Before',
  value_ranges_after: 'After',
  value_ranges_disabled: 'Disabled',
  value_ranges_date_range: 'Date range',
  value_ranges_daily_time_slot: 'Daily time slot',
  value_ranges_timezone: 'Timezone',

  //Modals
  value_ranges_add_event: 'Add Event',
  value_ranges_edit_event: 'Edit Event',
  value_ranges_add_default_events: 'Add Default Events',
  value_ranges_remove_modal_header: 'Are you sure you want to delete value range',
  value_ranges_remove_modal_body: 'Clicking remove will permanently delete the chosen value range',

  //Form
  value_range_form_name: 'Event Name',
  value_range_form_function: 'Function',
  value_range_form_sensor: 'Sensor',
  value_range_form_description: 'description',
  value_range_form_min: 'Min',
  value_range_form_max: 'Max',
  value_range_form_severity: 'Severity',
  value_range_form_start_day: 'Start Day',
  value_range_form_start_month: 'Start Month',
  value_range_form_start_time: 'Start Time',
  value_range_form_end_day: 'End Day',
  value_range_form_end_month: 'End Month',
  value_range_form_end_time: 'End Time',
  value_range_form_enable_events: 'Enable Events?',
  value_range_form_select_color: 'Selected color',
  value_range_form_notification_email: 'Email',
  value_range_form_notification_push_notification: 'Push Notification',
  value_range_form_notification_sms: 'SMS',
  value_range_form_notification_push: 'Push Notification',
  value_range_form_notification_call: 'Call',
  value_range_form_line_custom_color: 'Custom Line Color',
  value_range_form_marker_custom_color: 'Custom Marker Color',
  value_range_form_no_notifications: 'No Notifications',

  //Errors
  value_range_tooltip_severity:
    'Severities that are greater than 7 are considered severe. Severe events are signified with an exclamation mark.',
  value_range_error_add: 'Could not add event',
  value_range_error_edit: 'Could not edit event',
  value_range_name_is_required: 'Name is required',
  value_range_name_already_exists: 'Event name already exists for this device and sensor',
  value_range_name_incorect_time: 'Incorrect time format',
  value_range_min_greater_than_max: 'Min cannot be greater than max',
  value_range_min_equal_to_max: 'Min cannot be equal to max',
  value_range_min_max_is_required: 'Min or Max is required',
  value_range_error_occured: 'An error occurred',
  value_range_start_incorrect_time:
    'Start time has incorrect format. It should be HH:mm. Correct: 01:00. Incorrect: 1:00.',
  value_range_end_incorrect_time:
    'End time has incorrect time format. It should be HH:mm. Correct: 01:00. Incorrect: 1:00.',
  value_range_start_day_missing_start_month: 'Start day should have start month',
  value_range_end_day_missing_end_month: 'End day should have end month',
  value_range_start_month_missing_start_day: 'Start month should have start day',
  value_range_end_month_missing_end_day: 'End month should have end day',
  value_range_mixed_alphabets_error: 'Detected mixed alphabet usage, use only one language',

  /*
   * |==========|
   * | Commands |
   * |==========|
   */

  // Command State
  commands_command_state_pending: 'Pending',
  commands_command_state_sent: 'Sent',
  commands_command_state_cancelled: 'Cancelled',
  commands_command_state_status_ok: 'Ok',
  commands_command_state_status_nok: 'Not Okay',
  commands_command_state_unknown: 'Unknown',
  commands_command_state_timeout: 'Timeout',

  // Command Type
  commands_command_type_relay_switch: 'Relay Switch',
  commands_command_type_single_relay_switch: 'Single Relay Switch',
  commands_command_type_relay_switch_with_delay: 'Relay Switch With Delay',
  commands_command_type_relay_statuses: 'Relay Statuses',
  commands_command_type_send_config_over_mqtt: 'Send config over MQTT',
  commands_command_type_send_date_over_mqtt: 'Send date over MQTT',
  commands_command_type_modbus: 'Modbus',
  commands_command_type_tasmota_relay_switch: 'Tasmota Relay Command',
  commands_command_type_reset: 'Reset',
  commands_command_type_scheduled_relay_command: 'Scheduled Relay Command',
  commands_command_type_scheduled_relay_command_4: 'Scheduled Relay Commands (4)',
  // Errors
  commands_error_missing_device_number: 'Device Number missing or wrong.',

  // Buttons
  commands_btn_send_command: 'Send Command',
  commands_btn_refresh: 'Refresh',
  commands_btn_submit: 'Submit',

  // Tooltips
  commands_tooltip_edit: 'Edit',

  // Popups
  commands_send_command: 'Send Command',
  commands_edit_command: 'Edit Command',
  commands_command_type: 'Command Type',
  commands_parameters: 'Parameters',
  commands_parameter_name: 'Parameter Name',
  commands_parameter_value: 'Parameter Value',

  // Page
  commands_header: 'Commands',
  commands_type: 'Type',
  commands_status: 'Status',
  commands_relay_1_status: 'Relay 1 Status',
  commands_relay_2_status: 'Relay 2 Status',
  commands_created: 'Created',
  commands_sent: 'Sent',
  commands_executed: 'Executed',
  commands_relay_status: 'Relay Status',
  commands_relay_index: 'Relay Index',

  commands_sensor_index: 'Sensor Index',
  commands_slave_device_number: 'Slave Device Number',
  commands_hour: 'Hour',
  commands_minutes: 'Minutes',
  commands_auto_refresh: 'Auto-refresh',
  commands_no_commands: 'No commands have been sent to this device yet.',
  commands_no_parameters: 'This command takes no parameters.',
  commands_no_parameter_values: 'No values are available for this device.',
  commands_schedule_group: 'Schedule {{index}}',
  commands_cancel_command: 'Cancel command',
  commands_cancel_command_confirm:
    'This command has not been sent yet. Cancelling it stops it from being delivered to the device.',
  commands_cancel_command_success: 'Command cancelled',
  commands_send_command_success: 'Command sent',
  commands_btn_close: 'Close',
  commands_btn_keep: 'Keep it',
  commands_parameters_empty: 'No parameters',
  commands_command_id: 'ID',
  commands_error_send_failed: 'The command could not be sent.',
  commands_error_cancel_failed: 'The command could not be cancelled.',
  commands_error_parameters_failed: 'The parameters for this command could not be loaded.',
  commands_only_pending_can_be_cancelled: 'Only pending commands can be cancelled.',
  commands_last_updated: 'Updated {{time}}',
  commands_error_list_failed: 'The commands could not be loaded.',
  commands_range_hint: 'Allowed: {{min}}–{{max}}',

  /*
   * |=============|
   * | Copy Config |
   * |=============|
   */

  // Page
  copy_config_copy_config: 'Copy Config',
  copy_config_to_device_number_with_name_absent: 'To device: {{device_number}}',
  copy_config_to_device_number_with_name_present: 'To device: {{device_name}} ({{device_number}})',
  copy_config_from_device_number: 'From Device Number',
  copy_config_copy_config_type_label: 'Copy config type',
  copy_config_existing_device_option: 'Existing device',
  copy_config_new_device_option: 'New device',
  copy_config_should_copy_label: 'Should copy:',
  copy_config_should_copy_config_option: 'Config',
  copy_config_should_copy_value_ranges_option: 'Value ranges',

  // Buttons
  copy_config_btn_copy: 'Copy',

  //Toast
  copy_config_toast_copied_success: 'Device Config copied successfully.',
  copy_config_toast_copied_error: 'There was a problem trying to copy Device Config',
  copy_config_value_ranges_toast_copied_success: 'Value Ranges copied successfully.',
  copy_config_value_ranges_toast_copied_error: 'There was a problem trying to copy Value Ranges',

  /*
   * |============|
   * | Statistics |
   * |============|
   */
  statistics_header: 'Statistics',
  statistics_header_hours: 'Hours',
  statistics_header_quantity: 'Quantity',
  statistics_header_value: 'Value',
  statistics_quantity_minimum: 'Minimum',
  statistics_quantity_maximum: 'Maximum',
  statistics_quantity_average: 'Average',
  statistics_quantity_total: 'Total',
  statistics_quantity_hours: 'Hours',
  statistics_quantity_counters: 'Counters',
  statistics_error_title: 'Statistics unavailable',
  statistics_error_missing_config_title: 'Water meter configuration is incomplete',
  statistics_error_missing_config_description:
    'To calculate statistics, diameter, q3, and r must be defined for each water meter. Review the current values below and fill in the missing ones.',
  statistics_error_missing_field: 'Missing {{field}}',
  statistics_error_not_defined: 'Not defined',
  statistics_error_open_sensor_config: 'Open sensor configuration',
  statistics_error_update_values_hint: 'Update the missing values and return to this page.',
  statistics_error_contact_admin:
    'Please contact an administrator and ask them to define the missing water meter configuration values.',
  statistics_error_flow_unit_not_configured:
    'The selected sensor does not have a flow unit configured.',

  // Errors
  statistics_error_definition_for_q3:
    'Sensor {{name}} does not contain a definition for q3. Please visit the sensor configuration page.',
  statistics_eror_definition_for_diameter:
    'Sensor {{name}} does not contain a definition for diameter. Please visit the sensor configuration page.',
  statistics_error_definition_for_r:
    'Sensor {{name}} does not contain a definition for r. Please visit the sensor configuration page.',
  statistics_error_no_water_meters_found:
    'No water meters found. Please visit the device configuration page.',

  /*
   * |=====|
   * | Map |
   * |=====|
   */
  map_add_device: 'Add {{device}}',
  map_edit_device: 'Edit {{device}}',
  map_lat: 'Latitude',
  map_long: 'Longitude',
  map_coordinates: 'Coordinates',
  map_polygon: 'Polygon',
  map_linked_in_polygons: 'Linked in polygons:',
  map_loading: 'Loading...',

  // Button
  map_btn_link_device: 'Link Device',
  map_btn_submit: 'Submit',

  // Error
  map_err_add_device_to_map: 'Could not add device to map.',
  map_err_change_location: 'Could not change location.',
  map_err_link_polygon: 'Could not link to polygon.',

  // Device Modal
  map_btn_get_curr_location: 'Get Current Location',
  map_geolocation_not_supported: 'Geolocation is not supported by this browser.',
  map_lat_validation_message: 'Invalid latitude',
  map_long_validation_message: 'Invalid longitude',
  map_invalid_location: 'Invalid location',
  map_invalid_coordinate_input:
    'Invalid coordinate input. It should be "lat, long", e.g. 42.123, 23.123',

  // Set Coordinates Modal
  map_coordinates_modal_btn_label: 'Set Coordinates',
  map_coordinates_modal_title: 'Set Coordinates',
  map_coordinates_modal_target_option_self: 'For Self',
  map_coordinates_modal_target_option_company: 'For Company',
  map_coordinates_modal_target_option_user: 'For User',
  map_coordinates_modal_select_user_autocomplete_label: 'Username',
  map_coordinates_modal_save_for_self_warning_message:
    'Saving will set the current coordinates as the default for your current user. Are you sure you want to proceed?',
  map_coordinates_modal_save_for_company_warning_message:
    'Saving will set the current coordinates as the default for each user in your company. Are you sure you want to proceed?',
  map_coordinates_modal_save_for_user_warning_message:
    'Saving will set the current coordinates as the default for the selected user. Are you sure you want to proceed?',
  map_coordinates_modal_confirm_btn_label: 'Confirm',
  map_coordinates_modal_cancel_btn_label: 'Cancel',

  /*
   * |===============|
   * | Sensor Config |
   * |===============|
   */

  flow_time_units: 'Time units',
  flow_measurement_units: 'Units',
  flow_configuration_label: 'Flow Configuration',
  flow_coefficient: 'Coefficient',
  sensor_config_sensor_group_name: 'Sensor Group Name',
  flow_configuration_alert_message: 'Check the following flow configurations:\n{{message}}',
  flow_configuration_invalid_sensor_row_message:
    'Index: {{sensor_index}} with name: {{sensor_name}}\n',
  flow_configuration_sensor_name_not_set_label: 'Not set',

  /*
   * |===================|
   * | Device Prediction |
   * |===================|
   */
  device_prediction: 'Device Prediction',
  device_prediction_header: 'Time Series Analysis',
  device_prediction_sensor_name: 'Sensor Name',
  device_prediction_forward_days: 'Forward Days',
  device_prediction_backward_days: 'Backward Days',
  device_prediction_generate_btn: 'Generate',
  device_prediction_error: 'Error',
  device_prediction_error_msg_json: 'There was an issue generating prediction data.',
  device_prediction_error_msg_image: 'There was an issue generating the prediction image.',
  device_prediction_date: 'Date',
  device_prediction_trend: 'Trend',
  device_prediction_time: 'Time',
  device_prediction_legend_prediction: 'Prediction',
  device_prediction_legend_range: 'Prediction Range',
  device_prediction_legend_consumption: 'Current consumption',
  device_prediction_help_title: 'Help',
  device_prediction_help_title_input_guide: 'Input Guide',
  device_prediction_help_input_guide_text:
    '<strong> 1. Period </strong> - Users can select a date range from predefined options or set a custom range. The system analyzes the data within this chosen period to calculate future predictions, offering valuable insights. <br> <strong> 2. Sensor Name </strong> – select the sensor which you want to see their future predictions. <br> <strong> 3. Every </strong> - used for more detailed prediction in terms of granularity of time. <br> <strong> 4. Forward days </strong> - number of days the user wants to predict into the future. These predictions extend beyond the selected date range, giving insights into the expected consumption behavior. <br> <strong> 5. Backward days </strong> - represents the number of days to display on the graph and table, starting from the last day from the selected period. This showcases the historical real data received from the device during this specified period. <br> <strong> 6. Generate button </strong> – when clicking “Generate,” the system calculates the consumption based on the selected settings and generates predictions. The results are then displayed in both the Graph View and the Table View. <br> <strong> 7. Graph </strong> – The graph displays both the forward and backward days, presenting the real received data and showcasing the predicted data. <br> <strong> 8. Table </strong> - The table displays all data from the "from period" to the end of "forward days." Each row includes a specific date, time, and corresponding trend value, indicating the data\'s general direction or pattern over time. It helps understanding whether the values are increasing, decreasing, or stable during the predicted period.',
  device_prediction_help_title_legend: 'Legend',
  device_prediction_help_black:
    '<strong> Black Color </strong> - represents the real consumption data during the selected period (example: from 01 July to 31 July.)',
  device_prediction_help_red:
    '<strong> Red Color </strong> -  Represents real consumption if there is data from outside the selected period. In the picture above there is real data received from the device in the days that the model is set to predict. So, user can compare the predicted values (dark blue) with the red (real data)',
  device_prediction_help_dark_blue:
    " <strong> Dark Blue Color </strong> -  Represents the prediction for the selected period, which includes old data, and extends into the future with the forward days' predicted values. These predicted values provide insights into the expected consumption trend.",
  device_prediction_help_light_blue:
    '<strong> Light Blue Color </strong> -  Represents the range of the predicted values. It signifies that the actual consumption data could fall within this range, indicating the uncertainty associated with predictions.',
  device_prediction_help_example:
    "Example: The 'FROM' date is set to 1st July and the 'TO' date to 31st July, with 'Forward days' of 30, 'Backward days' to 30, and 'EVERY' 10 minutes, the graph will display the 30 days real consumption available (1st July to 1st August) and the predicted values for 30 days forward (from 1st August to 1st September). The table will show the real and predicted consumption for every 10 min from 1 July till 1 September 2023",

  /*
   * |=================|
   * | Counters Export |
   * |=================|
   */

  // Buttons and dropdowns
  counters_export_header: 'Data export',
  counters_readings_header: 'Readings',
  counters_export_search: 'Search',
  counters_export_download: 'Download',
  counters_export_format: 'Format',

  // Table columns
  counters_export_table_device_name: 'Device Name',
  counters_export_table_device_number: 'Device Number',
  counters_export_table_sensor_index: 'Sensor Index',
  counters_export_table_sensor_name: 'Sensor Name',
  counters_export_table_date: 'Date',
  counters_export_table_counters: 'Value',
  counters_export_table_prev_counters: 'Previous Value',
  counters_export_table_dt: 'Time Difference',
  counters_export_table_delta: 'Difference',
  counters_export_error_alert_message: 'An error occurred while generating the data.',
  counter_export_select_devices_label: 'Select devices',
  counter_export_select_sensors_label: 'Select sensors',
  counter_export_sensor_index: 'Sensor index: {{sensor_index}}',

  counters_export_maximum_capacity_error_message: 'Export maximum capacity reached!',
  counters_export_maximum_capacity_suggestion_message:
    'Please decrease the amount of selected devices or date period.',
  counters_export_empty_selection_title: 'Choose what to export',
  counters_export_empty_selection_message:
    'Select one or more devices or device groups to prepare the readings export.',
  counters_export_ready_title: 'Selection ready',
  counters_export_ready_message:
    'Selected {{devicesCount}} devices and {{groupsCount}} device groups. Click Search to preview the data or Download to export it.',
  counters_export_selected_device_toast: 'Selected device: {{deviceNumber}}',
  /*
   * |====================|
   * | Consumption Export |
   * |====================|
   */

  // Buttons and dropdowns
  consumption_export_header: 'Report',
  consumption_export_search: 'Search',
  consumption_export_download: 'Download',
  consumption_export_format: 'Format',
  consumption_export_aggregation_period: 'Aggregation period',
  consumption_export_aggregation_options_none: 'None',
  consumption_export_aggregation_options_daily: 'Daily',
  consumption_export_aggregation_options_weekly: 'Weekly',
  consumption_export_aggregation_options_monthly: 'Monthly',
  consumption_export_aggregation_options_yearly: 'Yearly',

  // Table columns

  consumption_export_table_device_number: 'Device Number',
  consumption_export_table_sensor_index: 'Sensor Index',
  consumption_export_table_address: 'Address',
  consumption_export_table_sensor_name: 'Sensor Name',
  consumption_export_table_first_reading_date: 'First Value Date',
  consumption_export_table_first_reading_value: 'First Value',
  consumption_export_table_last_reading_date: 'Last Value Date',
  consumption_export_table_last_reading_value: 'Last Value',
  consumption_export_table_delta: 'Difference',
  consumption_export_table_average: 'Average',
  consumption_export_table_consumption_for_period: 'Consumption for period',
  consumption_export_empty_selection_title: 'Choose what to export',
  consumption_export_empty_selection_message:
    'Select one or more devices or device groups to prepare the consumption export.',
  consumption_export_ready_title: 'Selection ready',
  consumption_export_ready_message:
    'Selected {{devicesCount}} devices and {{groupsCount}} device groups. Click Search to preview the data or Download to export it.',
  consumption_export_selected_device_toast: 'Selected device: {{deviceNumber}}',

  /*
   * |=================|
   * | Alarms Export |
   * |=================|
   */

  // Buttons and dropdowns
  alarms_export_header: 'Alarms',
  alarms_export_search: 'Search',
  alarms_export_refresh: 'Refresh',
  alarms_export_download: 'Download',
  alarms_export_format: 'Format',

  alarms_return_to_alarms: 'Return to Alarms',
  alarms_redirect_to_graph: 'Redirect to Graph',

  // Table columns
  alarms_export_table_date: 'Date',
  alarms_export_table_device_number: 'Device number',
  alarms_export_table_device_name: 'Device name',
  alarms_export_table_severity: 'Severity',
  alarm_severity_tooltip: 'Severity: {{value}} of 10',
  alarm_severity_none_tooltip: 'No severity reported for this alarm',
  alarms_export_table_sensor_index: 'Sensor index',
  alarms_export_table_sensor_name: 'Sensor name',
  alarms_export_table_alarm_type: 'Type',
  alarms_export_table_alarm_status: 'Status',
  alarms_export_table_description: 'Description',
  alarms_export_table_link_to_graph: 'Link to graph',
  alarms_export_chip_status_active: 'Active',
  alarms_export_chip_status_inactive: 'Inactive',
  alarms_export_switch_title_label: 'Аuto-refresh',
  alarms_export_error_alert_message: 'An error occurred while generating the data.',
  alarms_export_select_company_alert_message: 'Select a company before fetching alarms',
  alarms_export_select_device_or_company_alert_message:
    'Select a device or company before fetching alarms',
  alarms_export_error_too_big_query:
    'Retrieving history from Super Admin for all devices is too big of a request. Please select a company.',

  /*
   * |================|
   * | Inventory page |
   * |================|
   */

  //table
  device_inventory_page_header: 'Inventory',
  device_inventory_column_header_search: 'Search…',
  device_inventory_description: 'Description',
  device_inventory_device_name: 'Device Name',
  device_inventory_device_number: 'Device Number',
  device_inventory_hardware_version: 'Hardware Version',
  device_inventory_model: 'Model',
  device_inventory_software_version: 'Software Version',
  device_inventory_actions: 'Actions',
  nomenclature: 'Nomenclature',

  //modal
  device_inventory_manual: 'Manual',
  device_inventory_template: 'Template',
  device_inventory_add_device: 'Add Device',
  device_inventory_create_device_button: 'Create Device',
  device_inventory_delete_unlink_modal_body:
    'This will permanently delete the chosen device or you can unlink it from the selected company. The device will be unlinked from current account and all sub-accounts. If you want to unlink the device from the current account only, please go to "Link Device" page.',
  device_inventory_delete_modal_body: 'This will permanently delete the chosen device.',
  device_inventory_hardware_version_helper: 'The required format is X.X.X where X is a number',
  device_inventory_update_device_button: 'Update Device',
  device_inventory_update_device_title: 'Updating {{number}}',
  device_inventory_modal_delete_device_title: 'Delete Device {{number}} ?',
  device_inventory_software_version_helper:
    'The required format is X.X.X or  X.X.X- and X.X.X_ followed by characters, where X is a number',
  device_inventory_description_helper: 'Reached description length limit',
  device_inventory_device_number_helper:
    'Please enter 8 characters containing only letters (A-Z) and numbers (0-9).',
  device_inventory_modal_select_action: 'Select action for device {{number}}',
  device_inventory_reference_device_number: 'Select device for reference',
  device_inventory_nomenclature_required_for_model: 'Nomenclature is required for {{model}}',

  //success
  device_inventory_create_device_success: 'Device created successfully',
  device_inventory_update_device_success: 'Device updated successfully',
  device_inventory_delete_device_success: 'Device deleted successfully',
  device_inventory_unlink_device_success: 'Device successfully unlinked',
  device_inventory_rma_add_success: 'RMA record added successfully',

  //rma history
  device_inventory_rma_history_title: 'RMA History - {{number}}',
  device_inventory_rma_add_record: 'Add Record',
  device_inventory_rma_no_records: 'No RMA records for this device',
  device_inventory_rma_add_error: 'An error occurred while adding the RMA record',
  rma_record_date: 'Date',
  rma_record_date_required: 'Date is required',
  rma_record_type: 'Type',
  rma_record_category: 'Category',
  rma_record_comments: 'Comments',
  rma_record_save: 'Save',
  rma_record_back: 'Back',
  rma_type_INCIDENT: 'Incident',
  rma_type_DEVICE_EVENT: 'Device Event',
  rma_type_RMA: 'RMA',
  rma_category_BATTERY_REPLACEMENT: 'Battery Replacement',
  rma_category_SIM_CARD_CHANGE: 'SIM Card Change',
  rma_category_ENCLOSURE_DEGRADATION: 'Enclosure Degradation',
  rma_category_FLOOD_DAMAGE: 'Flood Damage',
  rma_category_ANTENNA_REPLACEMENT: 'Antenna Replacement',
  rma_category_POWER_SUPPLY_PROBLEM: 'Power Supply Problem',
  rma_category_PHYSICAL_DAMAGE: 'Physical Damage',
  rma_category_STOLEN: 'Stolen',
  rma_category_WRONG_CONFIGURATION: 'Wrong Configuration',
  rma_category_OTHER: 'Other',

  //error
  device_inventory_create_device_error: 'An error occurred while creating device',
  device_inventory_delete_device_error: 'An error occurred while deleting device',
  device_inventory_device_exists: 'Device already exists',
  device_inventory_empty_device_error: "Device number can't be empty",
  device_inventory_empty_reference_error: 'Select device for reference',
  device_inventory_empty_device_name_error: "Device name can't be empty",
  device_inventory_empty_hardware_error: "Hardware version can't be empty",
  device_inventory_empty_software_error: "Software version can't be empty",
  device_inventory_error: 'Could not load devices',
  device_inventory_update_device_error: 'An error occurred while updating device',
  device_inventory_already_exists_error: 'Device with this number already exists',
  device_inventory_empty_nomenclature_error: 'Nomenclature cannot be empty',
  device_inventory_empty_manufacturing_date_error: 'Manufacturing date cannot be empty',
  device_inventory_empty_warranty_period_error: 'Warranty period cannot be empty',

  /*
   * |====================|
   * | Transmissions page |
   * |====================|
   */

  //page
  transmissions_page_title: 'Transmissions',
  transmissions_page_refresh: 'Refresh',
  transmissions_page_export_csv: 'Export to CSV',
  transmissions_page_yes: 'Yes',
  transmissions_page_no: 'No',
  transmissions_page_error_message: 'Could not load transmissions',

  //table
  transmissions_table_device_number: 'Device Number',
  transmissions_table_device_name: 'Device Name',
  transmissions_table_last_transmission: 'Last Transmission',
  transmissions_table_next_transmission: 'Next Transmission',
  transmissions_table_days: 'Days',
  transmissions_table_transmission: 'Transmission',
  transmissions_table_count: 'Count',
  transmissions_table_customer: 'Customer',
  transmissions_table_address: 'Address',
  transmissions_table_ok: 'OK',
  transmissions_table_devEUI: 'devEUI',
  transmissions_table_simcard_number: 'SimCard Number',
  transmissions_table_simcard_provider: 'SimCard Provider',
  transmissions_table_apn: 'APN',

  /*
   * |===============|
   * | Device Config |
   * |===============|
   */

  // page
  device_config_period: 'Period',
  device_config_every: 'Every',

  // error
  device_config_error_record_period_postiive: 'Record period must be positive.',
  device_config_error_transmission_period_positive: 'Transmission period must be positive.',
  device_config_error_record_must_be_greater_than_transmission:
    'Record period cannot be greater than transmission period.',
  device_config_error_not_divisible: 'Record period is not divisible to transmission period.',
  device_config_error_max_threshold_reached:
    '{{curr}} records per transmission is more than the maximum {{max}}.',

  /*
   * |=======|
   * | Graph |
   * |=======|
   */
  graph_tabs_readings: 'Values',
  graph_tabs_prediction: 'Prediction',
  graph_tabs_average: 'Average',
  graph_tabs_previous: 'Previous',
  graph_column_sensor: 'Sensor',
  graph_column_index: 'Index',
  graph_column_device: 'Device',
  graph_column_device_name: 'Device Name',
  graph_column_date: 'Date',
  graph_column_readings: 'Value',
  graph_column_previous_readings: 'Previous Value',
  graph_column_delta: 'Difference',
  /*
   * |===============|
   * | Settings page |
   * |===============|
   */
  settings_page_header: 'Settings',
  settings_submit_success_msg: 'Settings saved',
  settings_submit_error_msg: 'Settings could not be saved',
  settings_input_invalid_format_error_msg: 'Invalid data format',
  settings_certificate_not_found_error: 'No certificate was found on this file path',
  settings_add_button: 'Add',
  settings_submit_button: 'Submit',
  settings_input_key_label: 'Key',
  settings_input_type_label: 'Type',
  settings_input_value_label: 'Value',
  settings_select_type_string: 'String',
  settings_select_type_number: 'Number',
  settings_select_type_boolean: 'Boolean',
  settings_select_type_object: 'Object',
  settings_logo_label: 'Logo',
  settings_dashboard_layout_label: 'Dashboard layout',
  settings_certificate_label: 'Certificate path',
  settings_device_panel_title: 'Device Panel Title',
  settings_sensor_panel_title: 'Sensor Panel Title',
  settings_header_home_label: 'Header Home Label (Portal)',
  settings_header_dashboard_label: 'Header Dashboard Label (Portal)',
  settings_footer_main_label: 'Footer Main Label (Portal)',
  settings_footer_link_label: 'Footer Link Label (Portal)',
  settings_footer_link_url: 'Footer Link URL (Portal)',
  settings_alarm_notification_display_period: 'Alarm Notification Display Period (hours) (Portal)',

  /* |===========|
   * | New Graph |
   * |===========|
   */

  //page
  new_graph_add_device_group_modal_title: 'Device Group Sensors "Every" Configuration',
  new_graph_add_device_group_modal_device_group: 'Device group: ',
  new_graph_add_device_group_modal_sensors_to_add: 'Sensors to add: ',
  new_graph_add_device_group_modal_every_selector_mode_per_device: 'Per Device',
  new_graph_add_device_group_modal_every_selector_mode_per_sensor: 'Per Sensor',
  new_graph_add_device_group_modal_sensor_limit_message:
    'You cannot exceed the graph limit of {{graphSensorsLimit}} sensors!',
  new_graph_add_device_group_modal_confirm_button: 'Confirm',
  new_graph_add_device_group_modal_cancel_button: 'Cancel',
  new_graph_select_sensor_heading: 'Select Sensor',
  new_graph_date_range_selection: 'Date Range Selection',
  new_graph_selected_sensors_heading: 'Selected Sensors',
  new_graph_selected_sensors_remove_all_tooltip: 'Clear all',
  new_graph_select_company_message: 'Please select a company',
  new_graph_show_sensors_statistics_label: 'Show Statistics',

  //sensor selection
  new_graph_device_group_label: 'Device Group',
  new_graph_device_label: 'Device',
  new_graph_sensor_label: 'Sensor',

  //date range selection
  new_graph_average_days_label: 'Average days',
  new_graph_time_series_prediction_period_label: 'Period',
  new_graph_auto_refresh_label: 'Refresh',
  new_graph_period_picker_heading: 'Period',
  new_graph_average_days_heading: 'Average',
  new_graph_time_series_prediction_period_heading: 'Time Series Prediction',
  new_graph_none_option: 'None',
  new_graph_day_option_one: '{{count}} day',
  new_graph_day_option_other: '{{count}} days',
  new_graph_week_option_one: '{{count}} week',
  new_graph_week_option_other: '{{count}} weeks',
  new_graph_month_option_one: '{{count}} month',
  new_graph_month_option_other: '{{count}} months',
  new_graph_year_option_one: '{{count}} year',
  new_graph_year_option_other: '{{count}} years',

  //tooltip
  new_graph_current_value_name: 'Current',
  new_graph_average_value_name: 'Average',
  new_graph_prediction_value_name: 'Prediction',

  //error
  new_graph_fetch_device_groups_error: 'Could not load device groups for company.',
  new_graph_fetch_devices_error: 'Could not load devices for company.',
  new_graph_fetch_device_config_error: 'Could not load the config of the selected device.',
  new_graph_fetch_device_ports_config_error: 'Could not load ports for the selected device.',
  new_graph_fetch_device_flow_error: 'Could not load flow for {{deviceName}}.',
  new_graph_fetch_device_flow_avg_error: 'Could not load average flow for {{deviceName}}.',
  new_graph_fetch_device_readings_error: 'Could not load readings for {{deviceName}}.',
  new_graph_fetch_device_readings_avg_error: 'Could not load average readings for {{deviceName}}.',
  new_graph_fetch_device_on_off_alarms_error: 'Could not load on/off alarms for {{deviceName}}.',
  new_graph_fetch_device_prediction_error: 'Could not load prediction for {{deviceName}}.',
  new_graph_sensor_already_in_state_error:
    'This specific sensor has already been added to the list.',

  /* |================|
   * | Billing Report |
   * |================|
   */
  billing_report_header: 'Billing Report',
  billing_report_btn_generate: 'Generate',
  billing_report_device_number: 'Device Number',
  billing_report_first_reading_date: 'First Reading Date',
  billing_report_last_reading_date: 'Last Reading Date',
  billing_report_readings: 'Readings',
  billing_report_battery: 'Battery',
  billing_report_signal: 'Signal',
  billing_report_total: 'Total',

  /* |================|
   * | Profile Page   |
   * |================|
   */
  profile_page_change_logo: 'Change logo',
  profile_page_logo_formats_message: 'Acceptable formats: PNG, JPEG',
  profile_page_name: 'Name',
  profile_page_email: 'Email',
  profile_page_language: 'Language',
  profile_page_password: 'Password',
  profile_page_change_language: 'Change language',
  profile_page_update_license: 'Update License',
  profile_page_change_password: 'Change password',
  profile_page_generate: 'Generate',
  profile_page_api_token: 'API Token',
  profile_page_client_id: 'Client ID',
  profile_page_client_secret: 'Client Secret',
  profile_page_show_client_id: 'Show client ID',
  profile_page_hide_client_id: 'Hide client ID',
  profile_page_show_client_secret: 'Show client secret',
  profile_page_hide_client_secret: 'Hide client secret',
  profile_page_api_token_label: 'API Token',
  profile_page_api_token_valid_for: 'Valid for {{duration}}.',
  profile_page_copy: 'Copy',
  profile_page_copied_to_clipboard: 'Copied to clipboard.',
  profile_page_failed_to_copy: 'Failed to copy to clipboard.',
  profile_page_token_generated_success: 'Token generated successfully.',
  profile_page_token_generate_error: 'Failed to generate token.',
  profile_page_header: 'Profile',
  profile_page_user_info_label: 'User Info',
  profile_page_license_label: 'License ',
  profile_page_license_type: 'License Type',
  profile_page_valid_from: 'Valid from',
  profile_page_valid_to: 'Valid To',
  profile_page_max_readings: 'Max Readings',
  profile_page_current_count: 'Current count',
  profile_page_first_reading: 'First Reading',
  profile_page_last_reading: 'Last Reading',
  profile_page_license_status: 'Status',
  profile_page_renew_license_button: 'Renew License',
  profile_page_deactivate_license_button: 'Deactivate License',
  profile_page_valid_license: 'Valid License',
  profile_page_invalid_license: 'Invalid License',
  profile_page_deactivate_license_success_message: 'License deactivated.',
  profile_page_deactivate_license_error_message: 'Could not deactivate license.',
  profile_page_deactivate_modal_title: 'License deactivation',
  profile_page_confirm_button: 'Confirm',
  profile_page_cancel_button: 'Cancel',
  profile_page_deactivate_license_modal_description:
    'Are you sure you want to deactivate this license?',
  profile_page_activate_license_modal_description:
    'Are you sure you want to activate this license?',
  profile_page_activate_modal_title: 'License Activation',
  profile_page_license_per_device: 'per device',
  profile_page_license_per_reading: 'per reading',
  profile_page_license_per_sensor: 'per sensor',
  profile_page_license_per_poc: 'per proof of concept (POC)',
  profile_page_license_per_remote_node: 'per remote node',
  profile_page_license_partial: 'partial',
  profile_page_logo_file_format_error: 'Invalid file type. Please upload an image.',
  profile_page_logo_size_error: 'File size exceeds 1MB. Please upload a smaller image.',
  profile_page_version_info: 'Version Info:',

  logo_error_message: 'Could not load company logo',

  profile_page_country: 'Country',
  profile_page_timezone: 'Timezone',
  profile_page_address: 'Address',
  profile_page_city: 'City',
  profile_page_municipality: 'Municipality',
  profile_page_area: 'Area',
  profile_page_zip_code: 'ZIP Code',
  profile_page_vat_number: 'VAT Number',
  profile_page_edit: 'Edit Account',
  profile_page_update_account_success: 'Account updated successfully',
  profile_page_license_info: 'License Info',

  /* |===============|
   * | Utility Rates |
   * |===============|
   */
  util_rates: 'Utility Rates',

  // table
  util_rates_name: 'Name',
  util_rates_price: 'Price',
  util_rates_currency: 'Currency',
  util_rates_unit: 'Unit',
  util_rates_private: 'Private',
  util_rate_company: 'Company',
  util_rate_created: 'Created',
  util_rates_updated: 'Updated',
  util_rates_actions: 'Actions',
  util_rates_tooltip_inspect: 'Inspect',

  // modals
  util_rates_add_modal_header: 'Add Utility Rate',
  util_rates_edit_modal_header: 'Edit {{name}}',
  util_rates_delete_modal_header: 'Delete {{name}}',
  util_rates_delete_modal_body: 'This will permanently delete the chosen utility rate',
  util_rates_confirm: 'Confirm',
  util_rates_cancel: 'Cancel',
  util_rates_loading: 'Loading...',
  util_rates_error: 'Error',
  util_rates_error_name_exists: 'Utility rate with this name already exists',

  // errors
  util_rate_fetch_company_error: 'Could not load companies',
  util_rate_fetch_util_rates_error: 'Could not load utility rates',

  // footer
  footer_powered_by: 'Powered by',
  util_rates_name_required: 'Name is required',
  util_rates_price_required: 'Price is required',

  /*
   * |=======|
   * | Icons |
   * |=======|
   */
  icon_type: 'Type',
  icon_type_device: 'Device',
  icon_type_sensor: 'Sensor',

  icon_scope: 'Scope',
  icon_scope_global: 'Global',
  icon_scope_company: 'Company',
  icon_scope_device: 'Device',
  icon_scope_sensor: 'Sensor',

  icon_input_device: 'Device',
  icon_input_sensor: 'Sensor',
  icon_input_name: 'Name',
  icon_input_company: 'Company',

  icon_btn_add_icon: 'Add Icon',
  icon_btn_upload_file: 'Upload File',
  icon_btn_cancel: 'Cancel',
  icon_btn_save: 'Submit',

  icon_table_name: 'Name',
  icon_table_scope: 'Scope',
  icon_table_icon: 'Icon',
  icon_table_actions: 'Actions',

  // errors
  icon_error_update_icon: 'Could not update icon',
  icon_error_unsupported_file_type: 'Invalid file type. Only JPEG, PNG, and SVG are allowed.',
  icon_error_error_occured: 'An error occurred',
  icon_error_enter_name: 'Please enter a name',
  icon_error_enter_icon: 'Please upload an icon',
  icon_error_select_company: 'Please select a company',
  icon_error_select_device: 'Please select a device',
  icon_error_select_sensor: 'Please select a sensor',

  /*
   * |=========================|
   * | Customer Billing Report |
   * |=========================|
   */
  customer_billing_report_account_id_table_header: 'Account Id',
  customer_billing_report_description_table_header: 'Description',
  customer_billing_report_customer_name_table_header: 'Customer Name',
  customer_billing_report_street_table_header: 'Street',
  customer_billing_report_quarter_table_header: 'Quarter',
  customer_billing_report_last_reading_table_header: 'Last Reading',
  customer_billing_report_last_reading_date_table_header: 'Last Reading Date',
  customer_billing_report_device_number_table_header: 'Device Number',
  customer_billing_report_last_config_date_table_header: 'Last Configuration Date',
  customer_billing_report_billing_group_table_header: 'Billing Group',
  customer_billing_report_meter_serial_table_header: 'Meter Serial',
  customer_billing_report_diameter_table_header: 'Diameter',
  customer_billing_report_meter_brand_table_header: 'Meter Brand',
  customer_billing_report_meter_model_table_header: 'Meter Model',
  customer_billing_report_default_error: 'An error occured while generating the report',
  customer_billing_report_contract_number_table_header: 'Contract number',
  customer_billing_report_device_name_table_header: 'Device name',
  customer_billing_report_sensor_name_table_header: 'Sensor name',

  /*
   * |======================|
   * | Scheduled Reports    |
   * |======================|
   */
  // Generated Reports Page
  generated_reports_header: 'Generated Reports',
  generated_reports_select_company_message: 'Please select a company to view generated reports',
  generated_reports_default_error: 'An error occurred while fetching generated reports',
  generated_reports_config_button: 'Config',
  generated_reports_config_name_header: 'Report Config Name',
  generated_reports_date_header: 'Report Date',
  generated_reports_type_header: 'Report Type',
  generated_reports_file_name_header: 'File Name',
  generated_reports_parameters_header: 'Parameters',

  // Report Configs Page
  report_configs_header: 'Report Configurations',
  report_configs_select_company_message: 'Please select a company to manage report configurations',
  report_configs_default_error: 'An error occurred while fetching report configurations',
  report_configs_name_header: 'Report Name',
  report_configs_type_header: 'Report Type',
  report_configs_occurrence_header: 'Occurrence',
  report_configs_device_groups_header: 'Device Groups',
  report_configs_email_list_header: 'Email List',
  report_configs_start_date_header: 'Start Date',
  report_configs_end_date_header: 'End Date',
  report_configs_next_execution_header: 'Next Execution',
  report_configs_actions_header: 'Actions',
  report_configs_delete_action: 'Delete',
  report_configs_delete_success: 'Report configuration deleted successfully',
  report_configs_delete_error: 'An error occurred while deleting the report configuration',
  report_configs_create_button: 'Create Report Config',
  report_configs_edit_action: 'Edit',

  // Report Config Form
  report_config_form_report_name: 'Report Name',
  report_config_form_report_type: 'Report Type',
  report_config_form_occurrence: 'Occurrence',
  report_config_form_device_groups: 'Device Groups',
  report_config_form_email_list: 'Email List',
  report_config_form_email_list_hint: 'Separate multiple emails with commas',
  report_config_form_start_date: 'Start Date',
  report_config_form_end_date: 'End Date',
  report_config_form_calculate: 'Calculate',
  report_config_form_calc_min: 'Minimum',
  report_config_form_calc_max: 'Maximum',
  report_config_form_calc_average: 'Average',
  report_config_form_cancel: 'Cancel',
  report_config_form_create: 'Create',
  report_config_form_update: 'Update',
  report_config_form_field_required: 'This field is required',
  report_config_form_device_groups_required: 'At least one device group must be selected',
  report_config_form_license_settings: 'License Report Settings',
  report_config_form_license_is_active: 'Is Active',
  report_config_form_license_is_valid: 'Is Valid',

  // Report Types
  report_type_consumption: 'Consumption Report',
  report_type_consumption_export: 'Consumption Export',
  report_type_customer_billing: 'Customer Billing Report',
  report_type_alarm: 'Alarm Report',
  report_type_transmission: 'Transmission Report',
  report_type_license: 'License Report',

  // Report Occurrence
  report_occurrence_daily: 'Daily',
  report_occurrence_weekly: 'Weekly',
  report_occurrence_monthly: 'Monthly',

  // Create/Edit Pages
  report_config_create_header: 'Create Report Configuration',
  report_config_create_success: 'Report configuration created successfully',
  report_config_create_error: 'An error occurred while creating the report configuration',
  report_config_edit_header: 'Edit Report Configuration',
  report_config_update_success: 'Report configuration updated successfully',
  report_config_update_error: 'An error occurred while updating the report configuration',
  report_config_fetch_error: 'An error occurred while fetching the report configuration',
  report_config_not_found: 'Report configuration not found',

  /*
   * |================|
   * | License Page   |
   * |================|
   */
  license_license_warning: 'License Warning',
  license_license_warning_per_reading_over_limit_singular: 'of type per reading exceeds the limit',
  license_license_warning_expire_singular: 'expiring soon',
  license_license_warning_per_reading_over_limit_plural: 'of type per readings exceed the limit',
  license_license_warning_expire_plural: 'expiring soon',
  license_max_count_error: 'Max count cannot be 0',

  license_header: 'License',
  license_table_company_name: 'Company Name',
  license_table_license_type: 'License Type',
  license_table_max_count: 'Max Count',
  license_table_valid_from: 'Valid From',
  license_table_valid_to: 'Valid To',
  license_table_first_reading_date: 'First Reading Date',
  license_table_last_reading_date: 'Last Reading Date',
  license_table_active: 'Active',
  license_table_valid: 'Valid',
  license_table_prepaid: 'Prepaid',
  license_table_yes: 'Yes',
  license_table_no: 'No',
  license_table_actions: 'Actions',

  license_warning_access_hold: 'Account Access on Hold',
  license_warning_access_hold_description:
    'Your access to the platform has been temporarily suspended due to unresolved payment. We encourage you to reach out to our support or connect with your designated representative to assist you in resolving this matter.',
  license_warning_no_valid_license: 'No valid license',
  license_warning_no_valid_license_description:
    'We could not find valid license associated with this account. Please reach out to your designated representative or contact our support for assistance.',
  license_warning_devices_count_limit_reached: 'Maximum Devices Reached',
  license_warning_devices_count_limit_reached_description:
    'You have reached the maximum devices you can link to the account from the license. If you want to add more, please contact your designated representative or our support for assistance.',
  license_warning_generic_title: 'No License',
  license_warning_generic_description: 'Can not proceed due to license issue.',
  license_info_renew_button: 'Renew License',
  license_info_deactivate_button: 'Deactivate License',
  license_info_renew_modal_button: 'Renew',
  license_info_used_readings: 'Used Readings',
  license_info_readings_left: 'Readings left',
  license_renew_license_button: 'Renew',
  license_deactivate_license_button: 'Deactivate',
  license_select_company_warning_message: 'Select a company to proceed',
  license_add_button: 'Add License',
  license_add_success_message: 'License created successfully',
  license_add_error_message: 'An error occured during the process',
  license_max_devices: 'Max Devices',
  license_max_readings: 'Max Readings',
  license_max_sensors: 'Max Sensors',
  license_company: 'Company',
  license_deactivate_warning: "This will suspend users' access to the platform",
  license_activate_warning: "This will restore users' access to the platform",
  license_activate_license_button: 'Activate',
  license_available_licenses: 'Available licenses',
  license_add_license: 'Add License',
  license_status_active: 'Active',
  license_status_inactive: 'Inactive',
  license_info_activate_button: 'Activate license',
  license_info_used_devices: 'Used devices',
  license_info_devices_left: 'Devices left',
  license_error_page_access_restricted: 'Access Restricted',
  license_valid_license_existing: 'You have a valid license of this type already!',
  license_conflicting_license_date: 'There is a valid license within the same period',

  license_date_range: 'Date range',
  license_validity_period: 'Validity period',
  provide_period: 'Please provide period',
  license_table_current_count: 'Current Count',

  //Password
  change_password: 'Change Password',
  current_password: 'Current Password',
  new_password: 'New Password',
  confirm_new_password: 'Confirm New Password',
  customer_info_saved: 'Customer Info Saved',

  password_min_length: 'Password must be at least 10 characters long',
  password_uppercase: 'Password must contain at least one uppercase letter',
  password_lowercase: 'Password must contain at least one lowercase letter',
  password_number: 'Password must contain at least one number',
  password_special_char: 'Password must contain at least one special character',
  password_mismatch: 'Passwords do not match',

  /*
   * |=========================|
   * |     Reset Password      |
   * |=========================|
   */
  reset_password_check_email_for_reset_link: 'Check your email for reset password link',
  reset_password_default_error_message: 'There was an error trying to reset your password',
  reset_password_change_password_label: 'Change password',
  reset_password_send_btn: 'Send',

  /*
   * |==============================|
   * |  Sensors and Network Config  |
   * |==============================|
   */

  //headers
  sensors_and_network_config_network_config: 'Device Network Configuration',
  sensors_and_network_config_device_details: 'Device Details',
  sensors_and_network_config_add_sensor: 'Add Sensor',

  //messages
  sensors_and_network_save_success: 'Config was saved successfully.',
  sensors_and_network_save_error: 'There was a problem saving the config.',
  sensors_and_network_formula_validation_default_error: 'Formula validation failed.',
  sensors_and_network_config_required_field_error: 'This field is required',

  //labels
  sensors_and_network_config_sensor_index: 'Sensor index',
  wildPoint_threshold: 'Wildpoint Threshold',
  scale: 'Scale',
  precision: 'Precision',
  initial_value: 'Initial Value',

  //buttons
  sensors_and_network_config_reset_btn: 'Reset',

  //tooltips
  config_tooltip_select_sensor_icon: 'Select sensor icon',
  config_tooltip_sensor_name: 'Sensor name',
  config_tooltip_enable_disable_sensor: 'Enable/Disable sensor',
  config_tooltip_reset_sensor: 'Reset new changes for this sensor',
  config_tooltip_reset_all_fields: 'Reset all fields to last saved values',
  config_tooltip_delete_sensor: 'Delete sensor',
  config_tooltip_sensor_description: 'Sensor description',
  config_tooltip_sensor_model: 'Sensor model',
  config_tooltip_sensor_serial_number: 'Sensor serial number',
  config_tooltip_sensor_manufacturer: 'The vendor of the sensor',
  config_tooltip_sensor_useInSensorsAggregation:
    "Indicates whether the data should be used by Thingslog's automatic data aggregator.",
  config_tooltip_sensor_visibility:
    "Determine whether the sensor should be visible in Thingslog's solution portal.",
  config_tooltip_sensor_scale:
    'The precision after the decimal point for all formula calculations.',
  config_tooltip_port_formula: 'Used for conversion of raw ADC values to mA or V',
  config_tooltip_sensor_formula:
    'Used for conversion of X in mA or V to the measured value for example - level, pressure, temperature and others.',
  config_tooltip_sensor_pulseRate: 'How much of the unit is one pulse',
  config_tooltip_sensor_offset:
    ' A digit number (+ or -) to which the readings sent by the device will be added.',
  config_tooltip_sensor_flow_units: 'Units of the flow rate - for example m3/h or kw/h',
  config_tooltip_sensor_flow_time_units:
    'The time period used for the unit calculation - for example seconds',
  config_tooltip_sensor_flow_conversion_coefficient:
    'How many time units are needed to achieve the unit from the raw readings',

  config_tooltip_sensor_diameter: 'Diameter of the pipe',
  config_tooltip_sensor_q3: 'Q3 coefficient of the water meter',
  config_tooltip_sensor_r: 'Water meter accuracy',
  config_tooltip_wildPoint_threshold:
    'Specifies the maximum allowed change between consecutive sensor readings. If exceeded, the packet is marked as faulty and discarded.',

  /*
   * |==============================|
   * |     Documentation Page       |
   * |==============================|
   */

  documentation_title: 'Documentation',
  documentation_platform: 'Platform Documentation',
  documentation_data_logger: 'Data Logger Documentation',
  documentation_communication_protocol: 'Communication Protocol Documentation',
  documentation_sign_in_main_menu: 'Sign up/Sign in and Main menu',
  documentation_account_management: 'ThingsLog account management',
  documentation_user_management: 'ThingsLog user management',
  documentation_data_loggers_configuration: 'ThingsLog data loggers configuration',
  documentation_alarms_value_range_events:
    'Configuring and reviewing ThingsLog alarms and value range events',
  documentation_modbus_slave_devices: 'Port & Sensor parameter builder for modbus slave devices',
  documentation_tasmota_devices: 'Setting up tasmota devices to work with ThingsLog platform',
  documentation_modbus_setup: 'Setting up Modbus slave devices to work with ThingsLog controllers',
  documentation_licenses: 'Licenses',
  documentation_old_user_manual: 'Old user manual',
  documentation_data_logger_manual: 'Thingslog data logger user manual',
  documentation_data_logger_command_guide: 'Thingslog data logger command guide',
  documentation_lora_protocol: 'Open Lora data protocol',
  documentation_mqtt_protocol: 'MQTT open data protocol',
  documentation_getting_started_training_guide: 'Getting Started Training Guide',
  documentation_view_pdf: 'View PDF',

  /*
   * |=====================|
   * | Device Nodes Page  |
   * |=====================|
   */

  device_nodes_table_no_links_found: 'No device node links found',
  device_nodes_table_error: 'Failed to retrieve device node links',
  device_nodes_table_source_device_number: 'Source Device Number',
  device_nodes_table_source_sensor_index: 'Source Sensor Index',
  device_nodes_table_target_device_number: 'Target Device Number',
  device_nodes_table_target_sensor_index: 'Target Sensor Index',
  device_nodes_table_is_active: 'Is Active',

  device_nodes_create_link: 'Create Link',
  device_nodes_source_device_required: 'Source device is required',
  device_nodes_source_device: 'Source Device',
  device_nodes_sensor_index_required: 'Sensor index is required',
  device_nodes_sensor_index_min: 'Sensor index must be at least 0',
  device_nodes_source_sensor_index: 'Source Sensor Index',
  device_nodes_target_device_required: 'Target device is required',
  device_nodes_target_device: 'Target Device',
  device_nodes_target_sensor_index: 'Target Sensor Index',
  device_nodes_is_active: 'Is Active',
  device_nodes_create_link_button: 'Create Link',
  device_nodes_same_device_error: 'Source and target cannot be the same device',

  device_nodes_delete_links: 'Delete Links',
  device_nodes_device_required: 'Device is required',
  device_nodes_device: 'Device',
  device_nodes_role_required: 'Role is required',
  device_nodes_role: 'Role',
  device_nodes_role_source: 'Source',
  device_nodes_role_target: 'Target',
  device_nodes_sensor_index: 'Sensor (Optional)',
  device_nodes_no_sensors_available: 'No sensors available',
  device_nodes_sensor_optional: 'Leave empty to delete all device links',
  device_nodes_delete_warning: 'Warning: This action cannot be undone!',
  device_nodes_delete_button: 'Delete Links',
  report_config_form_email_list_required: 'At least one email address is required',
  report_config_form_email_invalid: 'Invalid email address: {{email}}',
  report_config_form_email_no_spaces: 'Email addresses cannot contain spaces',
  report_configs_delete_confirm_title: 'Delete Report Configuration',
  report_configs_delete_confirm_message:
    'Are you sure you want to delete the report configuration "{{reportName}}"? This action cannot be undone.',
  report_configs_delete_cancel: 'Cancel',
  report_configs_delete_confirm: 'Delete',
  report_configs_deleting: 'Deleting...',

  /*
   * |====================|
   * | Sensors Data Page  |
   * |====================|
   */

  // Page
  sensors_data_no_selection_made: 'No Selection Made',
  sensors_data_no_selection_subtitle:
    'Use the controls above to select a device or group of devices to view their sensor readings.',

  // Device Readings Selector Generic
  sensors_data_select_device_group: 'Select Device Group',
  sensors_data_search_device_group: 'Search by device group name',
  sensors_data_add: 'Add',
  sensors_data_select_device: 'Select Device',
  sensors_data_search_device: 'Search by device name or number',
  sensors_data_select_sensor: 'Select Sensor',
  sensors_data_search_sensor: 'Search by sensor name or index',
  sensors_data_select_devices: 'Select Devices',
  sensors_data_select_sensor_type: 'Select Sensor Type',
  sensors_data_search_sensor_type: 'Search by sensor type',
  sensors_data_submit: 'Submit',

  // Device Readings Selector Specific
  sensors_data_select_sensors: 'Select Sensors',

  // Selected Items Display
  sensors_data_group: 'Group',

  // Readings Data Display
  sensors_data_click_to_view_readings: 'Click to view readings',
  sensors_data_view_sensor_data_subtitle: 'View sensor data and export information',
  sensors_data_raw: 'Raw',
  sensors_data_export: 'Export',
  sensors_data_format: 'Format',
  sensors_data_csv: 'CSV',
  sensors_data_excel: 'EXCEL',
  sensors_data_device_number: 'Device Number',
  sensors_data_device_name: 'Device Name',
  sensors_data_sensor_name: 'Sensor Name',
  sensors_data_date: 'Date',
  sensors_data_value: 'Value',
  sensors_data_no_data_available: 'No data available',
  sensors_data_sensor_index: 'Sensor Index',
  sensors_data_counters: 'Counters',
  sensors_data_previous: 'Previous',
  sensors_data_delta: 'Delta',
  sensors_data_collapse: 'Collapse',

  // Sensors Data Chart
  sensors_data_chart_no_data_available: 'No Data Available',
  sensors_data_chart_no_numeric_data_subtitle:
    'The request was successful, but no numeric data was returned for the selected range.',
  sensors_data_chart_min: 'min -',
  sensors_data_chart_max: 'max -',

  // Sensors Data Map
  sensors_data_map_loading: 'Loading map...',

  //Warranty Data
  manufacturing_date: 'Manufacturing Date',
  warranty_type: 'Warranty Type',
  warranty_extended_support: 'Extended Support',
  warranty_basic: 'Basic',

  warranty_status: 'Warranty Status',
  warranty_status_UNKNOWN: 'Unknown',
  warranty_status_IN_WARRANTY: 'In Warranty',
  warranty_status_EXPIRED: 'Expired',

  warranty_period_months: 'Warranty Period',

  install_date: 'Installation Date',
  install_warranty_exp_date: 'Install Warranty Expiration Date',
  install_warranty_period_months: 'Install Warranty Period',

  // Mobile Query Preview
  sensors_data_mobile_groups: 'Group(s)',
  sensors_data_mobile_sensors: 'Sensor(s)',
  sensors_data_mobile_types: 'Type(s)',
  sensors_data_mobile_no_filters_selected: 'No filters selected',

  // Quick Sensor Selector
  sensors_data_quick_select_sensor: 'Select a sensor to view readings',

  // Mobile Fab Button
  sensors_data_view_table: 'view table',
  sensors_data_view_chart: 'view chart',
  // Fallbacks added to keep locale keys aligned with English.
  device_counter_statistics_name_must_have_initialized_value:
    'Parameters Q3, R, and Diameter are required on pulse input connected to a water meter sensor.',
  device_groups_add_sensor_device: 'Add sensor and device to group',
  value_range_name_incorrect_time: 'Incorrect time format',
  value_range_error_occurred: 'An error occurred',

  // Dashboard localization additions
  cancel: 'Cancel',
  edit: 'Edit',
  save_btn: 'Save',
  resize: 'Resize',
  value: 'Value',
  time: 'Time',
  dashboards_title: 'Dashboards',
  dashboard_add_dashboard: 'Add Dashboard',
  dashboard_edit_dashboard: 'Edit Dashboard',
  dashboard_delete_dashboard: 'Delete Dashboard',
  dashboard_search_dashboards: 'Search dashboards',
  dashboard_search_by_name: 'Search by name',
  dashboard_create_dashboard: 'Create Dashboard',
  dashboard_save_dashboard: 'Save Dashboard',
  dashboard_name: 'Dashboard Name',
  dashboard_name_required: 'Dashboard name is required',
  dashboard_name_max_length: 'Dashboard name must be less than 100 characters',
  dashboard_time_period: 'Time Period',
  dashboard_dashboard_time_period: 'Dashboard Time Period',
  dashboard_dashboard_time_period_description:
    'Controls the default timeframe used by the dashboard and by widgets that inherit from it.',
  dashboard_save_period: 'Save Period',
  dashboard_edit_dashboard_period: 'Edit Dashboard Period',
  dashboard_period: 'Dashboard Period',
  dashboard_predefined_period: 'Predefined Period',
  dashboard_period_dashboard: 'Dashboard',
  dashboard_period_predefined: 'Predefined',
  dashboard_period_preset: 'Preset',
  dashboard_period_custom: 'Custom',
  dashboard_timespan_today: 'Today',
  dashboard_timespan_yesterday: 'Yesterday',
  dashboard_timespan_this_week: 'This Week',
  dashboard_timespan_this_month: 'This Month',
  dashboard_timespan_this_year: 'This Year',
  dashboard_timespan_past_1d: 'Past 1 Day',
  dashboard_timespan_past_1w: 'Past 1 Week',
  dashboard_timespan_past_1m: 'Past 1 Month',
  dashboard_timespan_past_1y: 'Past 1 Year',
  dashboard_start_date_required: 'Start date is required',
  dashboard_end_date_required: 'End date is required',
  dashboard_end_date_before_start_error: 'End date cannot be before start date',
  dashboard_predefined_period_required: 'Please select a predefined period',
  dashboard_default_dashboard_name: 'Default Dashboard',
  dashboard_loading: 'Loading...',
  dashboard_redirecting: 'Redirecting...',
  dashboards_load_error: 'Unable to load dashboards. Open the dashboards page and try again.',
  dashboard_load_error: 'Unable to load this dashboard. Refresh and try again.',
  dashboard_loading_data_sources: 'Loading data sources...',
  dashboard_data_sources_load_error:
    'Unable to load dashboard data sources. Widgets cannot be rendered yet.',
  dashboard_empty_title: 'Create your first widget',
  dashboard_empty_description:
    'This dashboard does not have any widgets yet. Add a widget to start displaying data here.',
  dashboard_confirm_changes_title: 'Confirm Changes',
  dashboard_save_layout_confirmation:
    'Are you sure you want to save your changes? All modifications will be applied to the dashboard.',
  dashboard_save_layout: 'Save layout',
  dashboard_edit_layout: 'Edit layout',
  dashboard_add_widget: 'Add Widget',
  dashboard_widgets: 'Widgets',
  dashboard_widget: 'Widget',
  dashboard_untitled_widget: 'Untitled widget',
  dashboard_no_widgets_yet: 'This dashboard does not have any widgets yet.',
  dashboard_create_widget: 'Create Widget',
  dashboard_save_widget: 'Save Widget',
  dashboard_edit_widget: 'Edit Widget',
  dashboard_delete_widget: 'Delete Widget',
  dashboard_yes_delete: 'Yes, delete',
  dashboard_widget_no_longer_exists: 'Widget no longer exists.',
  dashboard_widget_delete_confirmation_prefix: 'This will permanently delete the widget',
  dashboard_widget_delete_confirmation_suffix:
    'from the remote dashboard configuration. This action cannot be undone.',
  dashboards_empty_no_dashboards_title: 'No dashboards yet',
  dashboards_empty_no_results_title: 'No dashboards found',
  dashboards_empty_no_dashboards_description:
    'Start with a default dashboard or create an empty one.',
  dashboards_empty_no_results_description: 'Try another search or create a new dashboard.',
  dashboard_add_default_dashboard: 'Add Default Dashboard',
  dashboard_this_dashboard: 'this dashboard',
  dashboard_delete_confirmation: 'Are you sure you want to delete {{name}}?',
  dashboard_no_longer_exists: 'Dashboard no longer exists.',
  dashboard_edit_named_dashboard: 'Edit {{name}}',
  dashboard_fallback_dashboard: 'Dashboard',
  dashboard_edit_current_dashboard: 'Edit Current Dashboard',
  dashboard_all_dashboards: 'All Dashboards',
  dashboard_start_selector_guide: 'Start dashboard selector guide',
  dashboard_close_dashboards: 'Close dashboards',
  dashboard_open_dashboards: 'Open dashboards',
  dashboard_edit_period: 'Edit dashboard period',
  dashboard_variables: 'Variables',
  dashboard_hide_app_header: 'Hide app header',
  dashboard_show_app_header: 'Show app header',
  dashboard_start_tour: 'Start dashboard tour',
  dashboard_remove_from_favorites: 'Remove from favorites',
  dashboard_add_to_favorites: 'Add to favorites',
  dashboard_default_dashboard: 'Default dashboard',
  dashboard_set_as_default: 'Set as default',
  dashboard_favorite_tooltip:
    'Favorite dashboards are pinned near the top of this list for quick access.',
  dashboard_default_tooltip:
    'The default dashboard stays at the very top and is used as your primary dashboard.',
  dashboard_widget_type: 'Widget Type',
  dashboard_widget_type_required: 'Widget type is required',
  dashboard_widget_type_line_chart: 'Line chart',
  dashboard_widget_type_bar_chart: 'Bar chart',
  dashboard_widget_type_pie_chart: 'Pie chart',
  dashboard_widget_type_area_chart: 'Area chart',
  dashboard_widget_type_gauge: 'Gauge',
  dashboard_widget_type_value: 'Value',
  dashboard_widget_type_table: 'Table',
  dashboard_widget_title: 'Title',
  dashboard_widget_title_required: 'Title is required',
  dashboard_widget_title_max_length: 'Title must be less than 100 characters',
  dashboard_data_source: 'Data Source',
  dashboard_data_source_required: 'Data source is required',
  dashboard_query_settings: 'Query Settings',
  dashboard_no_data_sources_available: 'No data sources available',
  dashboard_no_data_sources_description:
    'Configure a dashboard data source before creating or editing widgets.',
  dashboard_select_data_source_to_configure_query: 'Select a data source to configure the query.',
  dashboard_query_type_not_supported: 'This query type is not supported yet.',
  dashboard_no_widget_timeframe: 'No widget timeframe',
  dashboard_no_widget_timeframe_description:
    'This widget query does not support a configurable time period.',
  dashboard_widget_time_period: 'Widget Time Period',
  dashboard_widget_time_period_description:
    'Use the dashboard period or override it only for this widget.',
  dashboard_edit_widget_timeframe: 'Edit widget timeframe',
  dashboard_edit_widget_timeframe_inherited:
    'Edit widget timeframe. Currently inherited from dashboard.',
  dashboard_widget_settings: 'Widget settings',
  dashboard_shift_scroll_to_zoom: 'Shift + scroll to zoom',
  dashboard_zoom_in: 'Zoom in',
  dashboard_zoom_out: 'Zoom out',
  dashboard_zoom_reset: 'Reset zoom',
  dashboard_inherited_timeframe_label: 'Dashboard: {{label}}',
  dashboard_edit_timeframe: 'Edit timeframe',
  dashboard_edit_widget_period: 'Edit Widget Period',
  dashboard_edit_named_widget: 'Edit {{name}}',
  dashboard_edit_named_widget_period: 'Edit {{name}} Period',
  dashboard_data_type: 'Data Type',
  dashboard_data_type_description: 'Choose whether readings or flow values should be preferred.',
  dashboard_readings: 'Readings',
  dashboard_query_time_period_description:
    'Use the dashboard period or override it for this widget query.',
  dashboard_battery_level: 'Battery Level',
  dashboard_battery_level_description: 'Limit the widget to a battery percentage range.',
  dashboard_signal_level: 'Signal Level',
  dashboard_signal_level_description: 'Limit the widget to a signal percentage range.',
  dashboard_signal_values: 'Signal Values',
  dashboard_signal_values_description: 'Choose which signal values should be shown by the widget.',
  dashboard_signal_value_required: 'Select at least one signal value',
  dashboard_transmission_values: 'Transmission Values',
  dashboard_transmission_values_description:
    'Choose which transmission values should be shown by the widget.',
  dashboard_transmission_value_required: 'Select at least one transmission value',
  dashboard_days: 'Days',
  dashboard_transmissions: 'Transmissions',
  dashboard_count: 'Count',
  dashboard_unit_days: 'days',
  dashboard_transmitting: 'Transmitting',
  devices: 'Devices',
  dashboard_device_sensor: 'Device Sensor',
  dashboard_device_sensor_description: 'Read one sensor from one device.',
  dashboard_device_required: 'Device is required',
  dashboard_sensor_required: 'Sensor is required',
  dashboard_devices_optional_description:
    'Pick devices to include. Leave empty to include all devices.',
  dashboard_no_devices_selected_uses_all: 'No devices selected. The widget will use all devices.',
  dashboard_device_groups: 'Device Groups',
  dashboard_device_groups_description: 'Read data from one or more device groups.',
  dashboard_select_one_device_group_required: 'Select at least one device group',
  dashboard_device_groups_optional_description:
    'Optional group sources to include in the mixed query.',
  dashboard_no_groups_selected: 'No groups selected.',
  dashboard_device_sensors: 'Device Sensors',
  dashboard_device_sensors_description:
    'Select the device and sensor index pairs this widget should read.',
  dashboard_device_sensors_optional_description:
    'Optional pairs of device numbers and sensor indexes.',
  dashboard_add_device_sensor_required: 'Add at least one device sensor',
  dashboard_add_device_sensor: 'Add Device Sensor',
  dashboard_remove_device_sensor: 'Remove device sensor',
  dashboard_device_sensor_types: 'Device Sensor Types',
  dashboard_device_sensor_types_description:
    'Select devices and the sensor type that should be read from them.',
  dashboard_device_sensor_types_optional_description:
    'Optional groups of devices matched by sensor type.',
  dashboard_add_device_sensor_type_required: 'Add at least one device sensor type',
  dashboard_sensor_type: 'Sensor Type',
  dashboard_add_sensor_type: 'Add Sensor Type',
  dashboard_remove_sensor_type: 'Remove sensor type',
  dashboard_variable: 'variable',
  dashboard_sensor_index_option: 'Sensor {{index}}',
  dashboard_visualization: 'Visualization',
  dashboard_visualization_description: 'Display options and chart styling',
  dashboard_visualization_show_grid: 'Show grid',
  dashboard_visualization_show_legend: 'Show legend',
  dashboard_visualization_render_legend_aside: 'Legend on the side',
  dashboard_visualization_show_legend_aside: 'Legend on the side',
  dashboard_visualization_show_x_axis_labels: 'Show X axis labels',
  dashboard_visualization_show_y_axis_labels: 'Show Y axis labels',
  dashboard_visualization_line_thickness: 'Line thickness',
  dashboard_visualization_interpolation: 'Interpolation',
  dashboard_visualization_show_points: 'Show points',
  dashboard_visualization_points_hidden_helper:
    'Points are automatically hidden when the time series has more than {{count}} data points for better visual clarity.',
  dashboard_visualization_stack_series: 'Stack series',
  dashboard_visualization_fill_opacity: 'Fill opacity',
  dashboard_visualization_orientation: 'Orientation',
  dashboard_visualization_grouping: 'Grouping',
  dashboard_visualization_bar_thickness: 'Bar thickness',
  dashboard_visualization_shape: 'Shape',
  dashboard_visualization_gauge_type: 'Gauge type',
  dashboard_visualization_bar_orientation: 'Bar orientation',
  dashboard_visualization_minimum: 'Minimum',
  dashboard_visualization_maximum: 'Maximum',
  dashboard_visualization_gauge_color: 'Gauge color',
  dashboard_visualization_value_color: 'Base color',
  dashboard_visualization_value_prefix: 'Prefix',
  dashboard_visualization_value_suffix: 'Suffix',
  dashboard_visualization_value_stacked: 'Prefix above, suffix below',
  dashboard_visualization_value_compact: 'Compact numbers',
  dashboard_visualization_value_target: 'Target',
  dashboard_visualization_value_show_target_percentage: 'Show % of target',
  dashboard_visualization_value_text_color: 'Custom text color',
  dashboard_visualization_colors: 'Colors',
  dashboard_value_percent_of_target: '{{percent}}% of target',
  dashboard_value_percent_above_target: '{{percent}}% above target',
  dashboard_visualization_show_value: 'Show value',
  dashboard_visualization_show_min_max: 'Show min/max',
  dashboard_visualization_show_thresholds: 'Show thresholds',
  dashboard_visualization_paginate_rows: 'Paginate rows',
  dashboard_visualization_thresholds: 'Thresholds',
  dashboard_visualization_add_threshold: 'Add threshold',
  dashboard_visualization_level: 'Level',
  dashboard_visualization_label: 'Label',
  dashboard_visualization_color: 'Color',
  dashboard_visualization_remove_threshold: 'Remove threshold',
  dashboard_visualization_threshold_warning: 'Warning',
  dashboard_visualization_threshold_critical: 'Critical',
  dashboard_visualization_threshold_named: 'Threshold {{index}}',
  dashboard_visualization_option_fine: 'Fine',
  dashboard_visualization_option_standard: 'Standard',
  dashboard_visualization_option_bold: 'Bold',
  dashboard_visualization_option_straight: 'Straight',
  dashboard_visualization_option_smooth: 'Smooth',
  dashboard_visualization_option_stepped: 'Stepped',
  dashboard_visualization_option_subtle: 'Subtle',
  dashboard_visualization_option_balanced: 'Balanced',
  dashboard_visualization_option_solid: 'Solid',
  dashboard_visualization_option_vertical: 'Vertical',
  dashboard_visualization_option_horizontal: 'Horizontal',
  dashboard_visualization_option_grouped: 'Grouped',
  dashboard_visualization_option_stacked: 'Stacked',
  dashboard_visualization_option_slim: 'Slim',
  dashboard_visualization_option_regular: 'Regular',
  dashboard_visualization_option_wide: 'Wide',
  dashboard_visualization_option_pie: 'Pie',
  dashboard_visualization_option_donut: 'Donut',
  dashboard_visualization_option_dial: 'Dial',
  dashboard_visualization_option_bar: 'Bar',
  dashboard_add_variable: 'Add Variable',
  dashboard_edit_variable: 'Edit Variable',
  dashboard_delete_variable: 'Delete Variable',
  dashboard_variable_no_longer_exists: 'Variable no longer exists.',
  dashboard_edit_named_variable: 'Edit {{name}}',
  dashboard_variable_edit_mode_description:
    'Local changes only affect this dashboard view for now. Remote changes update the saved variable and replace any local override for it.',
  dashboard_local: 'Local',
  dashboard_remote: 'Remote',
  dashboard_variable_name: 'Name',
  dashboard_variable_name_required: 'Name is required',
  dashboard_variable_name_pattern:
    'Use letters, numbers, and underscores. Start with a letter or underscore.',
  dashboard_variable_label: 'Label',
  dashboard_variable_label_required: 'Label is required',
  dashboard_variable_single: 'Single',
  dashboard_variable_multi: 'Multi',
  dashboard_variable_value: 'Value',
  dashboard_variable_values: 'Values',
  dashboard_variable_value_required: 'Value is required',
  dashboard_variable_at_least_one_value_required: 'At least one value is required',
  dashboard_variable_values_helper: 'Separate multiple values with commas.',
  dashboard_apply_locally: 'Apply locally',
  dashboard_no_variables_yet: 'No variables yet',
  dashboard_no_variables_description: 'Variables added to this dashboard will appear here.',
  dashboard_variable_value_count: '{{count}} value',
  dashboard_empty_value: 'Empty',
  dashboard_open_variable_actions: 'Open {{name}} actions',
  dashboard_variable_delete_confirmation_prefix: 'This will permanently delete the variable',
  dashboard_no_data_available: 'No data available',
  dashboard_widget_failed_to_load_data: 'Failed to load data',
  dashboard_click_to_retry: 'Click to retry',
  dashboard_chart_sampled_points_tooltip:
    'Showing a sampled set of real data points. Zoom in to reveal omitted points.',
  dashboard_chart_all_points_tooltip: 'Showing every data point in the current view.',
  dashboard_widget_no_areas: 'This widget has no areas to display.',
  dashboard_widget_no_bars: 'This widget has no bars to display.',
  dashboard_widget_no_points: 'This widget has no points to plot.',
  dashboard_widget_no_slices: 'This widget has no slices to display.',
  dashboard_widget_too_many_slices: 'Too many slices to display',
  dashboard_widget_too_many_slices_description:
    'This widget has {{slices}} slices. Drawing them all will make the dashboard slow to load and interact with, and the chart will be hard to read.',
  dashboard_widget_render_anyway: 'Display anyway',
  dashboard_table_settings_missing: 'Table settings are missing.',
  dashboard_widget_no_rows: 'This widget has no rows to display.',
  dashboard_gauge_settings_missing: 'Gauge settings are missing.',
  dashboard_value_settings_missing: 'Value settings are missing.',
  dashboard_widget_no_value: 'This widget has no value to display.',
  dashboard_widget_no_numeric_value: 'This widget has no numeric value to display.',
  dashboard_timestamp: 'Timestamp',
  dashboard_alarm_type: 'Alarm Type',
  dashboard_alarm_count: 'Alarm count',
  dashboard_level: 'Level',
  dashboard_series_index: 'Series {{index}}',
  dashboard_gauge_normal: 'Normal',
  dashboard_gauge_threshold: 'Threshold',
  dashboard_start_named_guide: 'Start {{title}} guide',
  dashboard_expand_named: 'Expand {{title}}',
  dashboard_expand_named_widget: 'Expand {{title}} widget',
  dashboard_close_named: 'Close {{title}}',
  dashboard_close_named_widget: 'Close {{title}} widget',
  dashboard_close_expanded_named_widget: 'Close expanded {{title}} widget',
  dashboard_tour_header_dashboards:
    'Dashboards opens the left selector so you can search and switch between dashboards.',
  dashboard_tour_header_settings:
    'Dashboard settings opens the right sidebar for renaming the dashboard and changing its time period.',
  dashboard_tour_header_title:
    'The title shows which dashboard you are viewing. Long names are truncated here to keep the header compact.',
  dashboard_tour_header_period:
    'The time period shows the range used by this dashboard. Click it to edit the dashboard period.',
  dashboard_tour_header_layout:
    'Edit layout lets you move and resize widgets. When editing is active, this becomes Save layout.',
  dashboard_tour_header_add_widget:
    'Add widget opens the right sidebar where you can create a new chart, table, or other dashboard widget.',
  dashboard_tour_header_variables:
    'Variables opens the right sidebar for dashboard variables. Variables can be reused by widgets as configurable values.',
  dashboard_tour_header_toggle_app_header:
    'This hides or shows the main application header to give the dashboard more vertical space.',
  dashboard_tour_dashboard_canvas:
    'This is the dashboard workspace. Widgets appear here; empty dashboards show a prompt to create the first widget.',
  dashboard_tour_selection_search:
    'Search filters dashboards by name without leaving the current page.',
  dashboard_tour_selection_add:
    'Add Dashboard opens the dashboard creation form in the right sidebar.',
  dashboard_tour_selection_list:
    'This list contains every matching dashboard. Click a row to open that dashboard.',
  dashboard_tour_selection_favorite:
    'The star marks a dashboard as a favorite. Favorites are saved to your account and shown near the top of the list.',
  dashboard_tour_selection_default:
    'The house marks your default dashboard. The default dashboard is saved to your account and always appears at the very top.',
  dashboard_tour_selection_all:
    'All Dashboards opens the full dashboard management page where you can create, edit, and delete dashboards.',
  dashboard_tour_widget_title: 'Title is the widget name displayed on the dashboard.',
  dashboard_tour_widget_type:
    'Widget type controls how the data is visualized, such as a line chart, bar chart, pie chart, area chart, or table.',
  dashboard_tour_widget_data_source:
    'Data Source chooses which source powers the widget. Changing it resets the query settings to match that source type.',
  dashboard_tour_query_single_device:
    'Device selects the individual device that the widget should read from. Variable-backed values are marked with the code icon.',
  dashboard_tour_query_single_sensor:
    'Sensor selects the sensor index on that device. The selected device controls which sensor options are available.',
  dashboard_tour_query_specific_devices:
    'Devices limits the battery widget to selected devices. Leave it empty when the widget should include every device.',
  dashboard_tour_query_battery_range:
    'Battery Level limits results to devices inside this percentage range.',
  dashboard_tour_query_device_groups:
    'Device Groups selects one or more saved groups. The widget requests readings for the devices in those groups.',
  dashboard_tour_query_device_sensor_list:
    'Device Sensors is a list of exact device and sensor pairs. Use it when each row should read a specific sensor from a specific device.',
  dashboard_tour_query_device_sensor_device: 'Device chooses which device this row reads from.',
  dashboard_tour_query_device_sensor_sensor:
    'Sensor chooses the sensor index for the selected device in this row.',
  dashboard_tour_query_device_sensor_add:
    'Add Device Sensor appends another device and sensor pair to the query.',
  dashboard_tour_query_device_type_list:
    'Device Sensor Types reads a sensor type across selected devices instead of selecting a single sensor index per row.',
  dashboard_tour_query_device_type_devices:
    'Devices chooses which devices are included for this sensor type row.',
  dashboard_tour_query_device_type_sensor_type:
    'Sensor Type identifies the analog or digital sensor type to request from the selected devices.',
  dashboard_tour_query_device_type_add:
    'Add Sensor Type appends another group of devices and sensor type criteria.',
  dashboard_tour_query_prefer_flow:
    'Data Type chooses whether the query should prefer raw readings or calculated flow values when the source supports both.',
  dashboard_tour_query_timespan_mode:
    'Time Period controls whether this widget inherits the dashboard period, uses a preset range, or uses custom dates.',
  dashboard_tour_query_timespan_preset:
    'Preset selects a relative period such as today, this month, or the past week.',
  dashboard_tour_query_timespan_custom:
    'Custom dates set an explicit start and end date. The end date cannot be before the start date.',
  dashboard_tour_widget_actions:
    'Cancel closes the form. Create or Save persists the widget configuration.',
  dashboard_tour_widget_delete:
    'Delete Widget removes the widget from the dashboard after confirmation.',
  dashboard_tour_dashboard_name:
    'Dashboard Name is the saved display name shown in headers and dashboard lists.',
  dashboard_tour_dashboard_period:
    'Time Period is the default data range for the dashboard. Widgets can inherit this period or use their own.',
  dashboard_tour_dashboard_timespan_mode:
    'Choose whether the dashboard uses a preset relative period or a custom date range.',
  dashboard_tour_dashboard_timespan_preset:
    'Preset selects a relative dashboard period such as today, this month, or the past week.',
  dashboard_tour_dashboard_timespan_custom:
    'Custom dates set an explicit dashboard start and end date. The end date cannot be before the start date.',
  dashboard_tour_variable_add:
    'Add Variable creates a new dashboard variable that widgets can use in their queries.',
  dashboard_tour_variable_row:
    'Each variable row shows the variable label and current value. Click the row to edit it.',
  dashboard_tour_variable_actions: 'The row action menu lets you edit or delete a variable.',
  dashboard_tour_variable_name_label:
    'Name is the internal variable key used by queries. Label is the human-friendly name shown in the UI.',
  dashboard_tour_variable_type:
    'Single variables hold one value. Multi variables hold several values.',
  dashboard_tour_variable_source:
    'Data Source can populate allowed variable values from a variable source, or stay empty for manual values.',
  dashboard_tour_variable_value:
    'Value is the current value for the variable. Multi-value variables accept multiple selected or comma-separated values.',
  dashboard_tour_variable_actions_form:
    'Cancel closes the form. Create, Save, or Apply locally stores the variable change.',
  dashboard_dialog_currently_open: 'Dialog is currently open.',
};

export type I18nTranslations = typeof i18n_en;

export default i18n_en;
